export const mockOption = {
    marketingChannel: [
        'Google搜尋',
        'FB社群',
        'YouTube',
        'PTT',
        '護理師介紹',
        '朋友介紹',
        '醫院實體廣告(海報、傳單)',
        '其他',
    ],
    hospitalBed: {
        categoryZh: '病床類型',
        options: [
            {
                title: '急診',
                wholeDayCharge: 300,
            },
            {
                title: '一般病床',
                wholeDayCharge: 0,
            },
            {
                title: '確診隔離病床(專責病房)',
                wholeDayCharge: 4800,
            },
            {
                title: '隔離病床',
                wholeDayCharge: 600,
            },
            {
                title: '居家照顧',
                wholeDayCharge: 0,
            },
            {
                title: '其它',
                wholeDayCharge: 0,
            },
        ],
    },
    symptom: {
        categoryZh: '症狀',
        options: [
            {
                title: 'COVID 陽性確診',
                wholeDayCharge: 0,
            },
            {
                title: '中風',
                wholeDayCharge: 0,
            },
            {
                title: '術後',
                wholeDayCharge: 0,
            },
            {
                title: '外傷',
                wholeDayCharge: 0,
            },
            {
                title: '骨折',
                wholeDayCharge: 0,
            },
            {
                title: '糖尿病',
                wholeDayCharge: 0,
            },
            {
                title: '發燒',
                wholeDayCharge: 0,
            },
            {
                title: '疥瘡',
                wholeDayCharge: 600,
            },
            {
                title: '攣縮',
                wholeDayCharge: 0,
            },
            {
                title: '壓瘡/褥瘡',
                wholeDayCharge: 0,
            },
            {
                title: '癌症',
                wholeDayCharge: 0,
            },
            {
                title: '肺結核等法定傳染病',
                wholeDayCharge: 0,
            },
            {
                title: '脊椎受傷',
                wholeDayCharge: 0,
            },
            {
                title: '心臟疾病',
                wholeDayCharge: 0,
            },
            {
                title: '肝臟疾病',
                wholeDayCharge: 0,
            },
            {
                title: '腸胃道疾病',
                wholeDayCharge: 0,
            },
            {
                title: '腎臟疾病',
                wholeDayCharge: 0,
            },
            {
                title: '失明',
                wholeDayCharge: 0,
            },
            {
                title: '失智',
                wholeDayCharge: 200,
            },
            {
                title: '憂鬱症',
                wholeDayCharge: 0,
            },
            {
                title: '帕金森氏症',
                wholeDayCharge: 0,
            },
            {
                title: '體重超過80公斤',
                wholeDayCharge: 200,
            },
            {
                title: '有攻擊傾向',
                wholeDayCharge: 200,
            },
            {
                title: '其他，請填寫於後方備註',
                wholeDayCharge: 0,
            },
        ],
    },
    servedItem: {
        categoryZh: '服務項目',
        options: [
            {
                title: '陪伴',
                wholeDayCharge: 0,
            },
            {
                title: '洗澡/擦澡/清潔',
                wholeDayCharge: 0,
            },
            {
                title: '換位/移位/翻身拍背',
                wholeDayCharge: 0,
            },
            {
                title: '餵食/備餐',
                wholeDayCharge: 0,
            },
            {
                title: '如廁',
                wholeDayCharge: 0,
            },
            {
                title: '更換尿布',
                wholeDayCharge: 0,
            },
            {
                title: '管灌',
                wholeDayCharge: 0,
            },
        ],
    },
    tube: {
        categoryZh: '管路狀況',
        options: [
            {
                title: '鼻胃管',
                wholeDayCharge: 0,
            },
            {
                title: '氣切管',
                wholeDayCharge: 0,
            },
            {
                title: '尿管',
                wholeDayCharge: 0,
            },
            {
                title: '胃造口',
                wholeDayCharge: 0,
            },
            {
                title: '腸造口',
                wholeDayCharge: 0,
            },
            {
                title: '引流管',
                wholeDayCharge: 0,
            },
            {
                title: '氧氣管/面罩',
                wholeDayCharge: 0,
            },
            {
                title: '其它管路',
                wholeDayCharge: 0,
            },
        ],
    },
    hospitalData: [
        {
            name: '臺大醫院-總院區',
            city: '臺北市',
            district: '中正區',
            address: '臺北市中正區中山南路7號',
            latitude: '25.040502',
            longitude: '121.519191',
            order: true,
        },
        {
            name: '臺大醫院-兒童醫院',
            city: '臺北市',
            district: '中正區',
            address: '臺北市中正區中山南路8號',
            latitude: '25.044473',
            longitude: '121.51884',
            order: true,
        },
        {
            name: '三軍總醫院-汀洲院區',
            city: '臺北市',
            district: '中正區',
            address: '臺北市中正區汀州路三段40號',
            latitude: '25.016669',
            longitude: '121.529732',
            order: true,
        },
        {
            name: '臺北市立聯合醫院-和平院區',
            city: '臺北市',
            district: '中正區',
            address: '臺北市中正區中華路二段33號',
            latitude: '',
            longitude: '',
            order: true,
        },
        {
            name: '郵政醫院',
            city: '臺北市',
            district: '中正區',
            address: '臺北市中正區福州街14號',
            latitude: '',
            longitude: '',
            order: true,
        },
        {
            name: '國泰醫院-臺北總院',
            city: '臺北市',
            district: '大安區',
            address: '臺北市大安區仁愛路四段280號',
            latitude: '25.037141',
            longitude: '121.553569',
            order: true,
        },
        {
            name: '臺北市立聯合醫院-仁愛院區',
            city: '臺北市',
            district: '大安區',
            address: '臺北市大安區仁愛路四段10號',
            latitude: '25.037774',
            longitude: '121.545224',
            order: true,
        },
        {
            name: '臺大醫院-癌醫中心',
            city: '臺北市',
            district: '大安區',
            address: '臺北市大安區基隆路三段155巷57號',
            latitude: '',
            longitude: '',
            order: true,
        },
        {
            name: '中心醫院',
            city: '臺北市',
            district: '大安區',
            address: '臺北市大安區忠孝東路四段77號',
            latitude: '25.042082',
            longitude: '121.547417',
            order: true,
        },
        {
            name: '宏恩醫院',
            city: '臺北市',
            district: '大安區',
            address: '臺北市大安區仁愛路四段61號',
            latitude: '25.038463',
            longitude: '121.546804',
            order: true,
        },
        {
            name: '中山醫院',
            city: '臺北市',
            district: '大安區',
            address: '臺北市大安區仁愛路四段112巷11號',
            latitude: '25.036834',
            longitude: '121.549997',
            order: true,
        },
        {
            name: '尹書田醫院',
            city: '臺北市',
            district: '大安區',
            address: '臺北市大安區建國南路二段276號',
            latitude: '25.025508',
            longitude: '121.537223',
            order: true,
        },
        {
            name: '秀傳醫院',
            city: '臺北市',
            district: '大安區',
            address: '臺北市大安區光復南路116巷1號',
            latitude: '25.043386',
            longitude: '121.55681',
            order: true,
        },
        {
            name: '臺北市立聯合醫院-中興院區',
            city: '臺北市',
            district: '大同區',
            address: '臺北市大同區鄭州路145號',
            latitude: '25.051251',
            longitude: '121.509396',
            order: true,
        },
        {
            name: '臺北醫學大學附設醫院',
            city: '臺北市',
            district: '信義區',
            address: '臺北市信義區吳興街252號',
            latitude: '25.027362',
            longitude: '121.563066',
            order: true,
        },
        {
            name: '臺北市立聯合醫院-松德院區',
            city: '臺北市',
            district: '信義區',
            address: '臺北市信義區松德路309號',
            latitude: '',
            longitude: '',
            order: true,
        },
        {
            name: '馬偕醫院-臺北總院',
            city: '臺北市',
            district: '中山區',
            address: '臺北市中山區中山北路二段92號',
            latitude: '25.059065',
            longitude: '121.522346',
            order: true,
        },
        {
            name: '臺北市立聯合醫院-林森院區',
            city: '臺北市',
            district: '中山區',
            address: '臺北市中山區林森北路530號',
            latitude: '',
            longitude: '',
            order: true,
        },
        {
            name: '協和婦女醫院',
            city: '臺北市',
            district: '中山區',
            address: '臺北市中山區松江路85巷5號',
            latitude: '25.050495',
            longitude: '121.533898',
            order: true,
        },
        {
            name: '泰安醫院',
            city: '臺北市',
            district: '中山區',
            address: '臺北市中山區民權東路2段92巷2-1號',
            latitude: '25.061711',
            longitude: '121.531501',
            order: true,
        },
        {
            name: '臺北市立聯合醫院-忠孝院區',
            city: '臺北市',
            district: '南港區',
            address: '臺北市南港區同德路87號',
            latitude: '',
            longitude: '',
            order: true,
        },
        {
            name: '萬芳醫院',
            city: '臺北市',
            district: '文山區',
            address: '臺北市文山區興隆路三段111號',
            latitude: '25.000164',
            longitude: '121.558172',
            order: true,
        },
        {
            name: '景美醫院',
            city: '臺北市',
            district: '文山區',
            address: '臺北市文山區羅斯福路六段280號',
            latitude: '24.99147',
            longitude: '121.539924',
            order: true,
        },
        {
            name: '臺北榮民總醫院',
            city: '臺北市',
            district: '北投區',
            address: '臺北市北投區石牌路二段201號',
            latitude: '25.120003',
            longitude: '121.520133',
            order: true,
        },
        {
            name: '三軍總醫院-北投分院',
            city: '臺北市',
            district: '北投區',
            address: '臺北市北投區新民路60號',
            latitude: '',
            longitude: '',
            order: true,
        },
        {
            name: '振興醫院',
            city: '臺北市',
            district: '北投區',
            address: '臺北市北投區振興街45號',
            latitude: '25.117755',
            longitude: '121.522414',
            order: true,
        },
        {
            name: '和信醫院',
            city: '臺北市',
            district: '北投區',
            address: '臺北市北投區立德路125號',
            latitude: '25.128797',
            longitude: '121.471935',
            order: true,
        },
        {
            name: '臺北市立關渡醫院',
            city: '臺北市',
            district: '北投區',
            address: '臺北市北投區知行路225巷12號',
            latitude: '25.120547',
            longitude: '121.466086',
            order: true,
        },
        {
            name: '北投健康管理醫院',
            city: '臺北市',
            district: '北投區',
            address: '臺北市北投區中和街2號',
            latitude: '',
            longitude: '',
            order: true,
        },
        {
            name: '三軍總醫院-內湖總院',
            city: '臺北市',
            district: '內湖區',
            address: '臺北市內湖區成功路二段325號',
            latitude: '25.072104',
            longitude: '121.589935',
            order: true,
        },
        {
            name: '中國醫藥大學附設醫院-臺北分院',
            city: '臺北市',
            district: '內湖區',
            address: '臺北市內湖區內湖路二段360號',
            latitude: '25.082418',
            longitude: '121.59077',
            order: true,
        },
        {
            name: '康寧醫院',
            city: '臺北市',
            district: '內湖區',
            address: '臺北市內湖區成功路五段420巷26號',
            latitude: '25.076134',
            longitude: '121.608926',
            order: true,
        },
        {
            name: '新光吳火獅紀念醫院',
            city: '臺北市',
            district: '士林區',
            address: '臺北市士林區文昌路95號',
            latitude: '25.09669',
            longitude: '121.520907',
            order: true,
        },
        {
            name: '臺北市立聯合醫院-陽明院區',
            city: '臺北市',
            district: '士林區',
            address: '臺北市士林區雨聲街105號',
            latitude: '',
            longitude: '',
            order: true,
        },
        {
            name: '長庚醫院-臺北長庚',
            city: '臺北市',
            district: '松山區',
            address: '臺北市松山區敦化北路199號',
            latitude: '25.055881',
            longitude: '121.549688',
            order: true,
        },
        {
            name: '臺安醫院',
            city: '臺北市',
            district: '松山區',
            address: '臺北市松山區八德路二段424號',
            latitude: '25.048278',
            longitude: '121.547318',
            order: true,
        },
        {
            name: '三軍總醫院-松山分院',
            city: '臺北市',
            district: '松山區',
            address: '臺北市松山區健康路131號',
            latitude: '25.054655',
            longitude: '121.557704',
            order: true,
        },
        {
            name: '博仁綜合醫院',
            city: '臺北市',
            district: '松山區',
            address: '臺北市松山區光復北路66號',
            latitude: '25.050182',
            longitude: '121.557673',
            order: true,
        },
        {
            name: '培靈醫院',
            city: '臺北市',
            district: '松山區',
            address: '臺北市松山區八德路四段355號',
            latitude: '',
            longitude: '',
            order: true,
        },
        {
            name: '臺大醫院-北護分院',
            city: '臺北市',
            district: '萬華區',
            address: '臺北市萬華區內江街87號',
            latitude: '25.041973',
            longitude: '121.503595',
            order: true,
        },
        {
            name: '西園醫院',
            city: '臺北市',
            district: '萬華區',
            address: '臺北市萬華區西園路二段270號',
            latitude: '25.028036',
            longitude: '121.494474',
            order: true,
        },
        {
            name: '臺北仁濟院附設醫院',
            city: '臺北市',
            district: '萬華區',
            address: '臺北市萬華區廣州街200號',
            latitude: '25.027688',
            longitude: '121.556229',
            order: true,
        },
        {
            name: '萬華醫院',
            city: '臺北市',
            district: '萬華區',
            address: '臺北市萬華區中華路二段606巷6號',
            latitude: '25.02426',
            longitude: '121.509816',
            order: true,
        },
        {
            name: '雙和醫院',
            city: '新北市',
            district: '中和區',
            address: '新北市中和區中正路291號',
            latitude: '24.99301',
            longitude: '121.493601',
            order: true,
        },
        {
            name: '怡和醫院',
            city: '新北市',
            district: '中和區',
            address: '新北市中和區連成路49號',
            latitude: '25.001962',
            longitude: '121.498519',
            order: true,
        },
        {
            name: '祥顥醫院',
            city: '新北市',
            district: '新莊區',
            address: '新北市新莊區思源路2號',
            latitude: '25.038666',
            longitude: '121.461002',
            order: true,
        },
        {
            name: '中祥醫院',
            city: '新北市',
            district: '中和區',
            address: '新北市中和區中山路二段140號',
            latitude: '25.003566',
            longitude: '121.5021',
            order: true,
        },
        {
            name: '蕙生醫院',
            city: '新北市',
            district: '中和區',
            address: '新北市中和區中山路二段551號',
            latitude: '',
            longitude: '',
            order: true,
        },
        {
            name: '亞東醫院',
            city: '新北市',
            district: '板橋區',
            address: '新北市板橋區南雅南路二段21號',
            latitude: '24.997479',
            longitude: '121.452782',
            order: true,
        },
        {
            name: '板新醫院',
            city: '新北市',
            district: '板橋區',
            address: '新北市板橋區中正路189號',
            latitude: '25.017169',
            longitude: '121.456527',
            order: true,
        },
        {
            name: '中英醫院',
            city: '新北市',
            district: '板橋區',
            address: '新北市板橋區文化路一段196號',
            latitude: '25.02013',
            longitude: '121.466342',
            order: true,
        },
        {
            name: '蕭中正醫院',
            city: '新北市',
            district: '板橋區',
            address: '新北市板橋區南雅南路一段15之1號',
            latitude: '25.007158',
            longitude: '121.456465',
            order: true,
        },
        {
            name: '板橋中興醫院',
            city: '新北市',
            district: '板橋區',
            address: '新北市板橋區忠孝路15號',
            latitude: '25.002223',
            longitude: '121.46017',
            order: true,
        },
        {
            name: '板橋國泰醫院',
            city: '新北市',
            district: '板橋區',
            address: '新北市板橋區忠孝路5號',
            latitude: '25.002154',
            longitude: '121.45994',
            order: true,
        },
        {
            name: '板英醫院',
            city: '新北市',
            district: '板橋區',
            address: '新北市板橋區文化路一段269號',
            latitude: '25.018437',
            longitude: '121.464555',
            order: true,
        },
        {
            name: '慈濟醫院-臺北分院',
            city: '新北市',
            district: '新店區',
            address: '新北市新店區建國路289號',
            latitude: '24.986335',
            longitude: '121.535719',
            order: true,
        },
        {
            name: '耕莘醫院-新店院區',
            city: '新北市',
            district: '新店區',
            address: '新北市新店區中正路362號',
            latitude: '24.976468',
            longitude: '121.535742',
            order: true,
        },
        {
            name: '耕莘醫院-安康院區',
            city: '新北市',
            district: '新店區',
            address: '新北市新店區車子路15號',
            latitude: '',
            longitude: '',
            order: true,
        },
        {
            name: '同仁醫院',
            city: '新北市',
            district: '新店區',
            address: '新北市新店區民權路89號',
            latitude: '24.98295',
            longitude: '121.537725',
            order: true,
        },
        {
            name: '新北仁康醫院',
            city: '新北市',
            district: '新店區',
            address: '新北市新店區安康路二段323號',
            latitude: '24.955754',
            longitude: '121.500511',
            order: true,
        },
        {
            name: '宏濟醫院',
            city: '新北市',
            district: '新店區',
            address: '新北市新店區安忠路57巷5號',
            latitude: '',
            longitude: '',
            order: true,
        },
        {
            name: '豐榮醫院',
            city: '新北市',
            district: '新店區',
            address: '新北市新店區安德街26巷3號',
            latitude: '',
            longitude: '',
            order: true,
        },
        {
            name: '宏慈療養院',
            city: '新北市',
            district: '新店區',
            address: '新北市新店區安泰路157號',
            latitude: '',
            longitude: '',
            order: true,
        },
        {
            name: '耕莘醫院-永和分院',
            city: '新北市',
            district: '永和區',
            address: '新北市永和區中興街80號',
            latitude: '25.012157',
            longitude: '121.517766',
            order: true,
        },
        {
            name: '永和復康醫院',
            city: '新北市',
            district: '永和區',
            address: '新北市永和區中和路575號',
            latitude: '25.004147',
            longitude: '121.511996',
            order: true,
        },
        {
            name: '馬偕醫院-淡水分院',
            city: '新北市',
            district: '淡水區',
            address: '新北市淡水區民生路45號',
            latitude: '25.139208',
            longitude: '121.461849',
            order: true,
        },
        {
            name: '馬偕醫院-淡水分院(馬偕樓)',
            city: '新北市',
            district: '淡水區',
            address: '新北市淡水區民權路47號',
            latitude: '25.139813',
            longitude: '121.460477',
            order: true,
        },
        {
            name: '公祥醫院',
            city: '新北市',
            district: '淡水區',
            address: '新北市淡水區中山路38號',
            latitude: '25.17037',
            longitude: '121.444278',
            order: true,
        },
        {
            name: '北新醫院',
            city: '新北市',
            district: '淡水區',
            address: '新北市淡水區演戲埔腳1-2號',
            latitude: '',
            longitude: '',
            order: true,
        },
        {
            name: '恩主公醫院',
            city: '新北市',
            district: '三峽區',
            address: '新北市三峽區復興路399號',
            latitude: '24.938444',
            longitude: '121.362904',
            order: true,
        },
        {
            name: '文化醫院',
            city: '新北市',
            district: '三峽區',
            address: '新北市三峽區介壽路一段199號',
            latitude: '24.931045',
            longitude: '121.378397',
            order: true,
        },
        {
            name: '清福醫院',
            city: '新北市',
            district: '三峽區',
            address: '新北市三峽區介壽路一段286號2樓',
            latitude: '',
            longitude: '',
            order: true,
        },
        {
            name: '新北市立聯合醫院-三重院區',
            city: '新北市',
            district: '三重區',
            address: '三重區新北大道一段3號',
            latitude: '25.061109',
            longitude: '121.49074',
            order: true,
        },
        {
            name: '祐民綜合醫院',
            city: '新北市',
            district: '三重區',
            address: '新北市三重區重新路二段2號',
            latitude: '25.063092',
            longitude: '121.499914',
            order: true,
        },
        {
            name: '三重中興醫院',
            city: '新北市',
            district: '三重區',
            address: '新北市三重區中興北街21號',
            latitude: '25.046627',
            longitude: '121.46967',
            order: true,
        },
        {
            name: '三重宏仁醫院',
            city: '新北市',
            district: '三重區',
            address: '新北市三重區三和路二段186號',
            latitude: '25.068892',
            longitude: '121.498716',
            order: true,
        },
        {
            name: '仁愛醫院',
            city: '新北市',
            district: '樹林區',
            address: '新北市樹林區文化街9號',
            latitude: '24.987239',
            longitude: '121.420062',
            order: true,
        },
        {
            name: '新北市立土城醫院',
            city: '新北市',
            district: '土城區',
            address: '新北市新北市土城區金城路二段6號',
            latitude: '',
            longitude: '',
            order: true,
        },
        {
            name: '元復醫院',
            city: '新北市',
            district: '土城區',
            address: '新北市土城區中央路二段318號',
            latitude: '24.973156',
            longitude: '121.440317',
            order: true,
        },
        {
            name: '仁安醫院',
            city: '新北市',
            district: '土城區',
            address: '新北市土城區中央路一段62號',
            latitude: '24.989715',
            longitude: '121.447403',
            order: true,
        },
        {
            name: '廣川醫院',
            city: '新北市',
            district: '土城區',
            address: '新北市土城區裕民路276號',
            latitude: '24.982421',
            longitude: '121.454968',
            order: true,
        },
        {
            name: '恩樺醫院',
            city: '新北市',
            district: '土城區',
            address: '新北市土城區中央路一段7-18號',
            latitude: '',
            longitude: '',
            order: true,
        },
        {
            name: '國泰醫院-汐止分院',
            city: '新北市',
            district: '汐止區',
            address: '新北市汐止區建成路59巷2號',
            latitude: '25.072893',
            longitude: '121.661188',
            order: true,
        },
        {
            name: '臺大醫院-金山分院',
            city: '新北市',
            district: '金山區',
            address: '新北市金山區玉爐路7號',
            latitude: '25.219614',
            longitude: '121.6284',
            order: true,
        },
        {
            name: '瑞芳礦工醫院',
            city: '新北市',
            district: '瑞芳區',
            address: '新北市瑞芳區一坑路71之2號',
            latitude: '25.108902',
            longitude: '121.802185',
            order: true,
        },
        {
            name: '天主教輔大醫院',
            city: '新北市',
            district: '泰山區',
            address: '新北市泰山區貴子路69號',
            latitude: '',
            longitude: '',
            order: true,
        },
        {
            name: '衛福部臺北醫院',
            city: '新北市',
            district: '新莊區',
            address: '新北市新莊區思源路127號',
            latitude: '25.043314',
            longitude: '121.459567',
            order: true,
        },
        {
            name: '衛福部樂生療養院',
            city: '新北市',
            district: '新莊區',
            address: '新北市新莊區中正路794號',
            latitude: '',
            longitude: '',
            order: true,
        },
        {
            name: '新仁醫院',
            city: '新北市',
            district: '新莊區',
            address: '新北市新莊區中正路395號',
            latitude: '25.03477',
            longitude: '121.445503',
            order: true,
        },
        {
            name: '益民醫院',
            city: '新北市',
            district: '新莊區',
            address: '新北市新莊區中港路127號',
            latitude: '25.040368',
            longitude: '121.455179',
            order: true,
        },
        {
            name: '新泰綜合醫院',
            city: '新北市',
            district: '新莊區',
            address: '新北市新莊區新樹路176號',
            latitude: '25.021698',
            longitude: '121.434337',
            order: true,
        },
        {
            name: '新莊仁濟醫院',
            city: '新北市',
            district: '新莊區',
            address: '新北市新莊區中環路1段28號',
            latitude: '',
            longitude: '',
            order: true,
        },
        {
            name: '大順醫院',
            city: '新北市',
            district: '新莊區',
            address: '新北市新莊區中正路215號',
            latitude: '',
            longitude: '',
            order: true,
        },
        {
            name: '英仁醫院',
            city: '新北市',
            district: '新莊區',
            address: '新北市新莊區大觀街46之2號',
            latitude: '',
            longitude: '',
            order: true,
        },
        {
            name: '名恩療養院',
            city: '新北市',
            district: '鶯歌區',
            address: '新北市鶯歌區鶯桃路二段62號',
            latitude: '',
            longitude: '',
            order: true,
        },
        {
            name: '衛福部八里療養院',
            city: '新北市',
            district: '八里區',
            address: '新北市八里區華富山路33號',
            latitude: '',
            longitude: '',
            order: true,
        },
        {
            name: '基隆長庚紀念醫院-本院',
            city: '基隆市',
            district: '安樂區',
            address: '基隆市安樂區麥金路222號',
            latitude: '25.120957',
            longitude: '121.722379',
            order: true,
        },
        {
            name: '基隆長庚紀念醫院-情人湖院區',
            city: '基隆市',
            district: '安樂區',
            address: '基隆市安樂區基金一路208巷200號',
            latitude: '25.149176',
            longitude: '121.707895',
            order: true,
        },
        {
            name: '南光神經精神科醫院',
            city: '基隆市',
            district: '安樂區',
            address: '基隆市安樂區基金一路91號',
            latitude: '25.138591',
            longitude: '121.718521',
            order: true,
        },
        {
            name: '暘基醫院',
            city: '基隆市',
            district: '安樂區',
            address: '基隆市安樂區基金一路129巷8號B1-5樓',
            latitude: '25.139089',
            longitude: '121.714544',
            order: true,
        },
        {
            name: '臺灣礦工醫院',
            city: '基隆市',
            district: '暖暖區',
            address: '基隆市暖暖區源遠路29號',
            latitude: '25.108199',
            longitude: '121.733227',
            order: true,
        },
        {
            name: '三軍總醫院-基隆孝二院區',
            city: '基隆市',
            district: '仁愛區',
            address: '基隆市仁愛區孝二路39號2樓',
            latitude: '25.129199',
            longitude: '121.73937',
            order: true,
        },
        {
            name: '衛福部基隆醫院',
            city: '基隆市',
            district: '信義區',
            address: '基隆市信義區信二路268號',
            latitude: '25.130583',
            longitude: '121.748118',
            order: true,
        },
        {
            name: '基隆市立醫院-本院',
            city: '基隆市',
            district: '信義區',
            address: '基隆市信義區東信路282號',
            latitude: '25.129869',
            longitude: '121.761951',
            order: true,
        },
        {
            name: '三軍總醫院-基隆正榮院區',
            city: '基隆市',
            district: '中正區',
            address: '基隆市中正區正榮街100號',
            latitude: '25.144905',
            longitude: '121.764255',
            order: true,
        },
        {
            name: '維德醫院',
            city: '基隆市',
            district: '中正區',
            address: '基隆市中正區調和街210號',
            latitude: '25.130709',
            longitude: '121.798863',
            order: true,
        },
        {
            name: '新昆明醫院',
            city: '基隆市',
            district: '中正區',
            address: '基隆市中正區中正路30號',
            latitude: '25.133492',
            longitude: '121.744795',
            order: true,
        },
        {
            name: '大園敏盛醫院',
            city: '桃園市',
            district: '大園區',
            address: '桃園市大園區華中街2號',
            latitude: '25.062244',
            longitude: '121.196092',
            order: true,
        },
        {
            name: '居善醫院',
            city: '桃園市',
            district: '大園區',
            address: '桃園市大園區大觀路910號',
            latitude: '25.058391',
            longitude: '121.166038',
            order: true,
        },
        {
            name: '林口長庚醫院',
            city: '桃園市',
            district: '龜山區',
            address: '桃園市龜山區公西村復興街5號',
            latitude: '25.061117',
            longitude: '121.368029',
            order: true,
        },
        {
            name: '大明醫院',
            city: '桃園市',
            district: '龜山區',
            address: '桃園市龜山區萬壽路二段964號',
            latitude: '24.995408',
            longitude: '121.338555',
            order: true,
        },
        {
            name: '桃園長庚醫院',
            city: '桃園市',
            district: '龜山區',
            address: '桃園市龜山區舊路村頂湖路123號、123之1號',
            latitude: '25.030771',
            longitude: '121.367329',
            order: true,
        },
        {
            name: '國軍桃園總醫院-民眾診療服務處',
            city: '桃園市',
            district: '龍潭區',
            address: '桃園市龍潭區中興路168號',
            latitude: '24.877123',
            longitude: '121.235434',
            order: true,
        },
        {
            name: '龍潭敏盛醫院',
            city: '桃園市',
            district: '龍潭區',
            address: '桃園市龍潭區中豐路168號',
            latitude: '24.875163',
            longitude: '121.214119',
            order: true,
        },
        {
            name: '聯新國際醫院-本院',
            city: '桃園市',
            district: '平鎮區',
            address: '桃園市平鎮區廣泰路77號',
            latitude: '24.94677',
            longitude: '121.205762',
            order: true,
        },
        {
            name: '宋俊宏婦幼醫院',
            city: '桃園市',
            district: '平鎮區',
            address: '桃園市平鎮區民族路199號',
            latitude: '24.9562',
            longitude: '121.210164',
            order: true,
        },
        {
            name: '秉坤婦幼醫院',
            city: '桃園市',
            district: '平鎮區',
            address: '桃園市平鎮區延平路2段129號',
            latitude: '24.948274',
            longitude: '121.211656',
            order: true,
        },
        {
            name: '陽明醫院',
            city: '桃園市',
            district: '平鎮區',
            address: '桃園市平鎮區延平路二段56號',
            latitude: '24.950141',
            longitude: '121.212564',
            order: true,
        },
        {
            name: '新永和醫院',
            city: '桃園市',
            district: '平鎮區',
            address: '桃園市平鎮區延平路一段81號',
            latitude: '24.951485',
            longitude: '121.219591',
            order: true,
        },
        {
            name: '衛福部桃園醫院',
            city: '桃園市',
            district: '桃園區',
            address: '桃園市桃園區中山路1492號',
            latitude: '24.977829',
            longitude: '121.269545',
            order: true,
        },
        {
            name: '聖保祿醫院',
            city: '桃園市',
            district: '桃園區',
            address: '桃園市桃園區建新街123號',
            latitude: '24.982589',
            longitude: '121.312894',
            order: true,
        },
        {
            name: '敏盛綜合醫院',
            city: '桃園市',
            district: '桃園區',
            address: '桃園市桃園區經國路168號',
            latitude: '25.016509',
            longitude: '121.307329',
            order: true,
        },
        {
            name: '臺北榮民總醫院-桃園分院',
            city: '桃園市',
            district: '桃園區',
            address: '桃園市桃園區成功路3段100號',
            latitude: '25.004642',
            longitude: '121.326155',
            order: true,
        },
        {
            name: '聯新國際醫院-桃新分院',
            city: '桃園市',
            district: '桃園區',
            address: '桃園市桃園區復興路195號',
            latitude: '24.989227',
            longitude: '121.309435',
            order: true,
        },
        {
            name: '德仁醫院',
            city: '桃園市',
            district: '桃園區',
            address: '桃園市桃園區桃鶯路245號',
            latitude: '24.984108',
            longitude: '121.318767',
            order: true,
        },
        {
            name: '振生醫院',
            city: '桃園市',
            district: '桃園區',
            address: '桃園市桃園區三民路2段288號',
            latitude: '24.999733',
            longitude: '121.309518',
            order: true,
        },
        {
            name: '衛福部桃園醫院-新屋分院',
            city: '桃園市',
            district: '新屋區',
            address: '桃園市新屋區新屋村14鄰新福2路6號',
            latitude: '24.969492',
            longitude: '121.106921',
            order: true,
        },
        {
            name: '天成醫院',
            city: '桃園市',
            district: '楊梅區',
            address: '桃園市楊梅區中山北路一段356號',
            latitude: '24.909002',
            longitude: '121.157417',
            order: true,
        },
        {
            name: '怡仁綜合醫院',
            city: '桃園市',
            district: '楊梅區',
            address: '桃園市楊梅區楊新北路321巷30號',
            latitude: '24.916987',
            longitude: '121.155875',
            order: true,
        },
        {
            name: '天晟醫院',
            city: '桃園市',
            district: '中壢區',
            address: '桃園市中壢區延平路155號',
            latitude: '24.962799',
            longitude: '121.229571',
            order: true,
        },
        {
            name: '中壢長榮醫院',
            city: '桃園市',
            district: '中壢區',
            address: '桃園市中壢區環中東路150號',
            latitude: '24.964663',
            longitude: '121.258638',
            order: true,
        },
        {
            name: '宏其婦幼醫院',
            city: '桃園市',
            district: '中壢區',
            address: '桃園市中壢區元化路223號',
            latitude: '24.961236',
            longitude: '121.226985',
            order: true,
        },
        {
            name: '承安醫院',
            city: '桃園市',
            district: '中壢區',
            address: '桃園市中壢區延平路643號',
            latitude: '24.953374',
            longitude: '121.222025',
            order: true,
        },
        {
            name: '祐民醫院',
            city: '桃園市',
            district: '中壢區',
            address: '桃園市中壢區民族路2段180號',
            latitude: '24.957387',
            longitude: '121.203844',
            order: true,
        },
        {
            name: '華揚醫院',
            city: '桃園市',
            district: '中壢區',
            address: '桃園市中壢區中北路二段316號',
            latitude: '24.953146',
            longitude: '121.230029',
            order: true,
        },
        {
            name: '新國民醫院',
            city: '桃園市',
            district: '中壢區',
            address: '桃園市中壢區復興路152號',
            latitude: '24.954162',
            longitude: '121.223572',
            order: true,
        },
        {
            name: '仁祥醫院',
            city: '桃園市',
            district: '中壢區',
            address: '桃園市中壢區中美路13.15.17號1-6樓',
            latitude: '24.957918',
            longitude: '121.227539',
            order: true,
        },
        {
            name: '長慎醫院',
            city: '桃園市',
            district: '中壢區',
            address: '桃園市中壢區中山東路二段525號1-2樓',
            latitude: '24.947374',
            longitude: '121.24624',
            order: true,
        },
        {
            name: '懷寧醫院',
            city: '桃園市',
            district: '中壢區',
            address: '桃園市中壢區志廣路119號',
            latitude: '24.961475',
            longitude: '121.205582',
            order: true,
        },
        {
            name: '中美醫院',
            city: '桃園市',
            district: '中壢區',
            address: '桃園市中壢區中美路95號',
            latitude: '24.958757',
            longitude: '121.225096',
            order: true,
        },
        {
            name: '培靈醫療社團法人關西醫院',
            city: '新竹縣',
            district: '關西鎮',
            address: '新竹縣關西鎮新富里11鄰石門33-1號',
            latitude: '24.757361',
            longitude: '121.189919',
            order: true,
        },
        {
            name: '天主教仁慈醫院',
            city: '新竹縣',
            district: '湖口鄉',
            address: '新竹縣湖口鄉忠孝路29號',
            latitude: '24.90056',
            longitude: '121.0455',
            order: true,
        },
        {
            name: '臺大醫院-竹北分院',
            city: '新竹縣',
            district: '竹北市',
            address: '新竹縣竹北市生醫路一段2號',
            latitude: '24.806552',
            longitude: '121.043651',
            order: true,
        },
        {
            name: '東元醫院',
            city: '新竹縣',
            district: '竹北市',
            address: '新竹縣竹北市縣政二路69號',
            latitude: '24.823884',
            longitude: '121.013722',
            order: true,
        },
        {
            name: '中國醫藥大學新竹附設醫院',
            city: '新竹縣',
            district: '竹北市',
            address: '新竹縣竹北市興隆路一段199號',
            latitude: '24.82404',
            longitude: '121.002',
            order: true,
        },
        {
            name: '大安醫院',
            city: '新竹縣',
            district: '竹北市',
            address: '新竹縣竹北市博愛街318巷6號',
            latitude: '24.8351',
            longitude: '121.008',
            order: true,
        },
        {
            name: '新仁醫院',
            city: '新竹縣',
            district: '竹北市',
            address: '新竹縣竹北市博愛街331號',
            latitude: '24.83564',
            longitude: '121.0079',
            order: true,
        },
        {
            name: '臺大醫院-竹東分院',
            city: '新竹縣',
            district: '竹東鎮',
            address: '新竹縣竹東鎮至善路52號',
            latitude: '24.71868',
            longitude: '121.0936',
            order: true,
        },
        {
            name: '臺北榮民總醫院-新竹分院',
            city: '新竹縣',
            district: '竹東鎮',
            address: '新竹縣竹東鎮中豐路一段81號',
            latitude: '24.7227',
            longitude: '121.0996',
            order: true,
        },
        {
            name: '林醫院',
            city: '新竹縣',
            district: '竹東鎮',
            address: '新竹縣竹東鎮東林路76號',
            latitude: '24.73683',
            longitude: '121.0912',
            order: true,
        },
        {
            name: '竹信醫院',
            city: '新竹縣',
            district: '竹東鎮',
            address: '新竹縣竹東鎮仁愛路196號',
            latitude: '24.73427',
            longitude: '121.0909',
            order: true,
        },
        {
            name: '臺大醫院-新竹分院',
            city: '新竹市',
            district: '北區',
            address: '新竹市北區金華里經國路一段442巷25號',
            latitude: '24.81671',
            longitude: '120.9799',
            order: true,
        },
        {
            name: '國軍新竹地區醫院-民眾診療服務處',
            city: '新竹市',
            district: '北區',
            address: '新竹市北區武陵路3號',
            latitude: '24.81537',
            longitude: '120.9624',
            order: true,
        },
        {
            name: '和平醫院',
            city: '新竹市',
            district: '北區',
            address: '新竹市北區和平路86-1號',
            latitude: '24.80892',
            longitude: '120.9556',
            order: true,
        },
        {
            name: '新竹新生醫院',
            city: '新竹市',
            district: '北區',
            address: '新竹市北區興南里西門街120號',
            latitude: '24.80157',
            longitude: '120.9634',
            order: true,
        },
        {
            name: '新中興醫院',
            city: '新竹市',
            district: '北區',
            address: '新竹市北區興南街43號',
            latitude: '24.80182',
            longitude: '120.9629',
            order: true,
        },
        {
            name: '新竹馬偕醫院',
            city: '新竹市',
            district: '東區',
            address: '新竹市東區光復里光復路二段690號',
            latitude: '24.80009',
            longitude: '120.9908',
            order: true,
        },
        {
            name: '新竹國泰醫院',
            city: '新竹市',
            district: '東區',
            address: '新竹市東區福德里中華路二段678號',
            latitude: '24.79826',
            longitude: '120.9652',
            order: true,
        },
        {
            name: '南門綜合醫院',
            city: '新竹市',
            district: '東區',
            address: '新竹市東區成功里林森路20號',
            latitude: '24.80222',
            longitude: '120.9697',
            order: true,
        },
        {
            name: '大順醫院',
            city: '苗栗縣',
            district: '大湖鄉',
            address: '苗栗縣大湖鄉中正路48之5號',
            latitude: '24.4224',
            longitude: '120.8676',
            order: true,
        },
        {
            name: '衛福部苗栗醫院',
            city: '苗栗縣',
            district: '苗栗市',
            address: '苗栗縣苗栗市為公路747號',
            latitude: '24.57566',
            longitude: '120.8404',
            order: true,
        },
        {
            name: '弘大醫院',
            city: '苗栗縣',
            district: '苗栗市',
            address: '苗栗縣苗栗市新東街125號',
            latitude: '24.55152',
            longitude: '120.821',
            order: true,
        },
        {
            name: '大千綜合醫院-南勢醫院',
            city: '苗栗縣',
            district: '苗栗市',
            address: '苗栗縣苗栗市南勢里南勢52號',
            latitude: '24.519593',
            longitude: '120.788286',
            order: true,
        },
        {
            name: '苗栗新生醫院',
            city: '苗栗縣',
            district: '苗栗市',
            address: '苗栗縣苗栗市維新里新東街117號',
            latitude: '24.55156',
            longitude: '120.8207',
            order: true,
        },
        {
            name: '協和醫院',
            city: '苗栗縣',
            district: '苗栗市',
            address: '苗栗縣苗栗市中正路1367號',
            latitude: '24.54128',
            longitude: '120.8173',
            order: true,
        },
        {
            name: '大千綜合醫院',
            city: '苗栗縣',
            district: '苗栗市',
            address: '苗栗縣苗栗市恭敬路36號',
            latitude: '24.55006',
            longitude: '120.8149',
            order: true,
        },
        {
            name: '大川醫院',
            city: '苗栗縣',
            district: '苗栗市',
            address: '苗栗縣苗栗市中正路416號',
            latitude: '24.56049',
            longitude: '120.8221',
            order: true,
        },
        {
            name: '通霄光田醫院',
            city: '苗栗縣',
            district: '通霄鎮',
            address: '苗栗縣通霄鎮中山路88號',
            latitude: '24.489298',
            longitude: '120.678417',
            order: true,
        },
        {
            name: '為恭紀念醫院-本院',
            city: '苗栗縣',
            district: '頭份市',
            address: '苗栗縣頭份市信義路128號',
            latitude: '24.6871',
            longitude: '120.9073',
            order: true,
        },
        {
            name: '為恭紀念醫院-東興院區',
            city: '苗栗縣',
            district: '頭份市',
            address: '苗栗縣頭份市水源路417巷11號',
            latitude: '24.66992',
            longitude: '120.918',
            order: true,
        },
        {
            name: '為恭紀念醫院-仁愛院區',
            city: '苗栗縣',
            district: '頭份市',
            address: '苗栗縣頭份市仁愛路116號',
            latitude: '24.6875',
            longitude: '120.9082',
            order: true,
        },
        {
            name: '重光醫院',
            city: '苗栗縣',
            district: '頭份市',
            address: '苗栗縣頭份市中華路1039號',
            latitude: '24.68648',
            longitude: '120.9081',
            order: true,
        },
        {
            name: '崇仁醫院',
            city: '苗栗縣',
            district: '頭份市',
            address: '苗栗縣頭份市東興路110號',
            latitude: '24.68374',
            longitude: '120.9043',
            order: true,
        },
        {
            name: '苑裡李綜合醫院-本院',
            city: '苗栗縣',
            district: '苑裡鎮',
            address: '苗栗縣苑裡鎮和平路168號',
            latitude: '24.44182',
            longitude: '120.6527',
            order: true,
        },
        {
            name: '苑裡李綜合醫院-中華院區',
            city: '苗栗縣',
            district: '苑裡鎮',
            address: '苗栗縣苑裡鎮中華路137號',
            latitude: '24.43838',
            longitude: '120.6537',
            order: true,
        },
        {
            name: '慈祐醫院',
            city: '苗栗縣',
            district: '竹南鎮',
            address: '苗栗縣竹南鎮民治街17號',
            latitude: '24.68477',
            longitude: '120.8786',
            order: true,
        },
        {
            name: '大眾醫院',
            city: '苗栗縣',
            district: '竹南鎮',
            address: '苗栗縣竹南鎮光復路304號',
            latitude: '24.69075',
            longitude: '120.8795',
            order: true,
        },
        {
            name: '國軍臺中總醫院-中清院區',
            city: '臺中市',
            district: '北區',
            address: '臺中市北區忠明路500號',
            latitude: '24.162924',
            longitude: '120.67221',
            order: true,
        },
        {
            name: '臺中維新醫院',
            city: '臺中市',
            district: '北區',
            address: '臺中市北區育德路185號',
            latitude: '24.15714',
            longitude: '120.6723',
            order: true,
        },
        {
            name: '中國醫藥大學兒童醫院',
            city: '臺中市',
            district: '北區',
            address: '臺中市北區學士路95號',
            latitude: '24.15677',
            longitude: '120.6811',
            order: true,
        },
        {
            name: '中國醫藥大學附設醫院',
            city: '臺中市',
            district: '北區',
            address: '臺中市北區育德路2號',
            latitude: '24.157284',
            longitude: '120.681002',
            order: true,
        },
        {
            name: '臺安醫院-雙十分院',
            city: '臺中市',
            district: '北區',
            address: '臺中市北區雙十路二段29號',
            latitude: '24.152984',
            longitude: '120.688629',
            order: true,
        },
        {
            name: '新亞東婦產科醫院',
            city: '臺中市',
            district: '北區',
            address: '臺中市北區中清路一段403號',
            latitude: '24.16363',
            longitude: '120.674',
            order: true,
        },
        {
            name: '勝美醫院',
            city: '臺中市',
            district: '北區',
            address: '臺中市北區五權路480',
            latitude: '24.15307',
            longitude: '120.6827',
            order: true,
        },
        {
            name: '弘光科技大學附設老人醫院',
            city: '臺中市',
            district: '北屯區',
            address: '臺中市北屯區太原路三段1141號',
            latitude: '24.16268',
            longitude: '120.7232',
            order: true,
        },
        {
            name: '澄清復健醫院',
            city: '臺中市',
            district: '北屯區',
            address: '臺中市北屯區太原路3段1142號',
            latitude: '24.16143',
            longitude: '120.7215',
            order: true,
        },
        {
            name: '茂盛醫院',
            city: '臺中市',
            district: '北屯區',
            address: '臺中市北屯區昌平路一段30-6號',
            latitude: '24.16665',
            longitude: '120.6942',
            order: true,
        },
        {
            name: '聯安醫院',
            city: '臺中市',
            district: '北屯區',
            address: '臺中市北屯區東山路一段37號',
            latitude: '24.17067',
            longitude: '120.6992',
            order: true,
        },
        {
            name: '全民醫院',
            city: '臺中市',
            district: '北屯區',
            address: '臺中市北屯區中清路二段516號',
            latitude: '24.18164',
            longitude: '120.6666',
            order: true,
        },
        {
            name: '博愛外科醫院',
            city: '臺中市',
            district: '北屯區',
            address: '臺中市北屯區文心路三段431號',
            latitude: '24.1735',
            longitude: '120.6679',
            order: true,
        },
        {
            name: '聯合中醫醫院',
            city: '臺中市',
            district: '北屯區',
            address: '臺中市北屯區大連路二段36號',
            latitude: '24.17595',
            longitude: '120.6831',
            order: true,
        },
        {
            name: '大甲李綜合醫院',
            city: '臺中市',
            district: '大甲區',
            address: '臺中市大甲區八德街2號',
            latitude: '24.35078',
            longitude: '120.6181',
            order: true,
        },
        {
            name: '光田醫院-大甲院區',
            city: '臺中市',
            district: '大甲區',
            address: '臺中市大甲區經國路321號',
            latitude: '24.34658',
            longitude: '120.6167',
            order: true,
        },
        {
            name: '順安醫院',
            city: '臺中市',
            district: '大甲區',
            address: '臺中市大甲區光明路6號',
            latitude: '24.3437',
            longitude: '120.6256',
            order: true,
        },
        {
            name: '美德醫院',
            city: '臺中市',
            district: '大甲區',
            address: '臺中市大甲區幸福里長安路20號',
            latitude: '24.38692',
            longitude: '120.6641',
            order: true,
        },
        {
            name: '大里仁愛醫院',
            city: '臺中市',
            district: '大里區',
            address: '臺中市大里區東榮路483號',
            latitude: '24.10926',
            longitude: '120.6804',
            order: true,
        },
        {
            name: '霧峰澄清醫院',
            city: '臺中市',
            district: '大里區',
            address: '臺中市大里區成功路55號',
            latitude: '24.08576',
            longitude: '120.6994',
            order: true,
        },
        {
            name: '達明眼科醫院',
            city: '臺中市',
            district: '大里區',
            address: '臺中市大里區中興路二段490號',
            latitude: '24.11139',
            longitude: '120.6901',
            order: true,
        },
        {
            name: '新菩提醫院',
            city: '臺中市',
            district: '大里區',
            address: '臺中市大里區中興路二段619',
            latitude: '24.11463',
            longitude: '120.6891',
            order: true,
        },
        {
            name: '清泉醫院',
            city: '臺中市',
            district: '大雅區',
            address: '臺中市大雅區三和里雅潭路四段80號',
            latitude: '24.21694',
            longitude: '120.6665',
            order: true,
        },
        {
            name: '中國醫藥大學附設醫院-臺中東區分院',
            city: '臺中市',
            district: '東區',
            address: '臺中市東區自由路三段296號',
            latitude: '24.14255',
            longitude: '120.6948',
            order: true,
        },
        {
            name: '臺新醫院',
            city: '臺中市',
            district: '東區',
            address: '臺中市東區振興路439-2號',
            latitude: '24.13039',
            longitude: '120.7055',
            order: true,
        },
        {
            name: '臺安醫院',
            city: '臺中市',
            district: '東區',
            address: '臺中市東區進化路203號',
            latitude: '24.14898',
            longitude: '120.6941',
            order: true,
        },
        {
            name: '東勢農民醫院',
            city: '臺中市',
            district: '東勢區',
            address: '臺中市東勢區豐勢路297號',
            latitude: '24.253712',
            longitude: '120.829157',
            order: true,
        },
        {
            name: '衛福部豐原醫院',
            city: '臺中市',
            district: '豐原區',
            address: '臺中市豐原區安康路100號',
            latitude: '24.24271',
            longitude: '120.7253',
            order: true,
        },
        {
            name: '中國醫藥大學附設醫院-豐原分院',
            city: '臺中市',
            district: '豐原區',
            address: '臺中市豐原區中正路199號',
            latitude: '24.25167',
            longitude: '120.7184',
            order: true,
        },
        {
            name: '惠盛醫院',
            city: '臺中市',
            district: '豐原區',
            address: '臺中市豐原區中正路268號',
            latitude: '24.252087',
            longitude: '120.7162',
            order: true,
        },
        {
            name: '杏豐醫院',
            city: '臺中市',
            district: '豐原區',
            address: '臺中市豐原區三民路106號',
            latitude: '24.25369',
            longitude: '120.7202',
            order: true,
        },
        {
            name: '漢忠醫院',
            city: '臺中市',
            district: '豐原區',
            address: '臺中市豐原區中正路218號',
            latitude: '24.25198',
            longitude: '120.7177',
            order: true,
        },
        {
            name: '豐安醫院',
            city: '臺中市',
            district: '豐原區',
            address: '臺中市豐原區中正路115號',
            latitude: '24.25166',
            longitude: '120.7207',
            order: true,
        },
        {
            name: '福平醫院',
            city: '臺中市',
            district: '豐原區',
            address: '臺中市豐原區中正路71號',
            latitude: '24.25253',
            longitude: '120.7215',
            order: true,
        },
        {
            name: '新惠生醫院',
            city: '臺中市',
            district: '豐原區',
            address: '臺中市豐原區圓環北路一段319號',
            latitude: '24.25856',
            longitude: '120.7195',
            order: true,
        },
        {
            name: '祥恩醫院',
            city: '臺中市',
            district: '豐原區',
            address: '臺中市豐原區中興路35號',
            latitude: '24.24815',
            longitude: '120.7176',
            order: true,
        },
        {
            name: '大同中醫醫院',
            city: '臺中市',
            district: '豐原區',
            address: '臺中市豐原區下街里仁愛街11號',
            latitude: '24.25242',
            longitude: '120.7175',
            order: true,
        },
        {
            name: '天心中醫醫院',
            city: '臺中市',
            district: '豐原區',
            address: '臺中市豐原區田心里中山路206號',
            latitude: '24.24059',
            longitude: '120.7124',
            order: true,
        },
        {
            name: '中山醫學大學附設醫院',
            city: '臺中市',
            district: '南區',
            address: '臺中市南區建國北路一段110號',
            latitude: '24.12175',
            longitude: '120.6499',
            order: true,
        },
        {
            name: '中山醫學大學附設醫院-中興分院',
            city: '臺中市',
            district: '南區',
            address: '臺中市南區復興路2段11號',
            latitude: '24.11812',
            longitude: '120.6586',
            order: true,
        },
        {
            name: '宏恩醫院-龍安分院',
            city: '臺中市',
            district: '南區',
            address: '臺中市南區德富路145巷2號',
            latitude: '24.119574',
            longitude: '120.655176',
            order: true,
        },
        {
            name: '宏恩醫院',
            city: '臺中市',
            district: '南區',
            address: '臺中市南區復興路二段38-13號',
            latitude: '24.12023',
            longitude: '120.6608',
            order: true,
        },
        {
            name: '臺中監獄培德醫院',
            city: '臺中市',
            district: '南屯區',
            address: '臺中市南屯區培德路9號',
            latitude: '24.14265',
            longitude: '120.5962',
            order: true,
        },
        {
            name: '林新醫院',
            city: '臺中市',
            district: '南屯區',
            address: '臺中市南屯區惠中路3段36號',
            latitude: '24.14904',
            longitude: '120.6402',
            order: true,
        },
        {
            name: '友仁醫院',
            city: '臺中市',
            district: '南屯區',
            address: '臺中市南屯區五權西路二段197號',
            latitude: '24.13983',
            longitude: '120.6495',
            order: true,
        },
        {
            name: '陽光精神科醫院',
            city: '臺中市',
            district: '清水區',
            address: '臺中市清水區大楊南街98號',
            latitude: '24.28113',
            longitude: '120.6092',
            order: true,
        },
        {
            name: '清濱醫院',
            city: '臺中市',
            district: '清水區',
            address: '臺中市清水區港埠路四段195號',
            latitude: '24.28312',
            longitude: '120.5489',
            order: true,
        },
        {
            name: '光田醫院-沙鹿總院',
            city: '臺中市',
            district: '沙鹿區',
            address: '臺中市沙鹿區沙田路117號',
            latitude: '24.23532',
            longitude: '120.5588',
            order: true,
        },
        {
            name: '童綜合醫院-沙鹿院區',
            city: '臺中市',
            district: '沙鹿區',
            address: '臺中市沙鹿區成功西街8號',
            latitude: '24.24294',
            longitude: '120.5606',
            order: true,
        },
        {
            name: '清海醫院',
            city: '臺中市',
            district: '石岡區',
            address: '臺中市石岡區金星里石岡街下坑巷41-2號',
            latitude: '24.25123',
            longitude: '120.7741',
            order: true,
        },
        {
            name: '國軍臺中總醫院-民眾診療服務處',
            city: '臺中市',
            district: '太平區',
            address: '臺中市太平區中山路二段348號',
            latitude: '24.15081',
            longitude: '120.7301',
            order: true,
        },
        {
            name: '長安醫院',
            city: '臺中市',
            district: '太平區',
            address: '臺中市太平區永平路1段9號',
            latitude: '24.13114',
            longitude: '120.7197',
            order: true,
        },
        {
            name: '新太平澄清醫院',
            city: '臺中市',
            district: '太平區',
            address: '臺中市太平區中興路100號',
            latitude: '24.12728',
            longitude: '120.7154',
            order: true,
        },
        {
            name: '賢德醫院-本院',
            city: '臺中市',
            district: '太平區',
            address: '臺中市太平區宜昌路420號',
            latitude: '24.14509',
            longitude: '120.7141',
            order: true,
        },
        {
            name: '賢德醫院-樹孝院區',
            city: '臺中市',
            district: '太平區',
            address: '臺中市太平區樹孝路36號',
            latitude: '24.15085',
            longitude: '120.717',
            order: true,
        },
        {
            name: '臺中慈濟醫院',
            city: '臺中市',
            district: '潭子區',
            address: '臺中市潭子區豐興路一段88號',
            latitude: '24.19569',
            longitude: '120.7219',
            order: true,
        },
        {
            name: '烏日林新醫院',
            city: '臺中市',
            district: '烏日區',
            address: '臺中市烏日區榮和路168號',
            latitude: '24.10959',
            longitude: '120.598',
            order: true,
        },
        {
            name: '烏日澄清醫院',
            city: '臺中市',
            district: '烏日區',
            address: '臺中市烏日區光明路419號',
            latitude: '24.11113',
            longitude: '120.6502',
            order: true,
        },
        {
            name: '童綜合醫院-梧棲院區',
            city: '臺中市',
            district: '梧棲區',
            address: '臺中市梧棲區臺灣大道八段699號',
            latitude: '24.24729',
            longitude: '120.5425',
            order: true,
        },
        {
            name: '明德醫院',
            city: '臺中市',
            district: '梧棲區',
            address: '臺中市梧棲區仁美街33巷50號',
            latitude: '24.25373',
            longitude: '120.5358',
            order: true,
        },
        {
            name: '忠港醫院',
            city: '臺中市',
            district: '梧棲區',
            address: '臺中市梧棲區文化里中興路49號',
            latitude: '24.25252',
            longitude: '120.536',
            order: true,
        },
        {
            name: '亞洲大學附屬醫院',
            city: '臺中市',
            district: '霧峰區',
            address: '臺中市霧峰區福新路222號',
            latitude: '24.05356',
            longitude: '120.6862',
            order: true,
        },
        {
            name: '本堂澄清醫院',
            city: '臺中市',
            district: '霧峰區',
            address: '臺中市霧峰區中正路718號',
            latitude: '24.05358',
            longitude: '120.6965',
            order: true,
        },
        {
            name: '衛福部臺中醫院',
            city: '臺中市',
            district: '西區',
            address: '臺中市西區廣民里三民路1段199號',
            latitude: '24.14023',
            longitude: '120.6757',
            order: true,
        },
        {
            name: '私立臺中仁愛之家-靜和醫院',
            city: '臺中市',
            district: '西區',
            address: '臺中市西區吉龍里南屯路1段158號',
            latitude: '24.13372',
            longitude: '120.6594',
            order: true,
        },
        {
            name: '林森醫院',
            city: '臺中市',
            district: '西區',
            address: '臺中市西區三民里三民路一段152-1號',
            latitude: '24.1359',
            longitude: '120.6731',
            order: true,
        },
        {
            name: '臺中榮民總醫院',
            city: '臺中市',
            district: '西屯區',
            address: '臺中市西屯區臺灣大道4段1650號',
            latitude: '24.1843',
            longitude: '120.6046',
            order: true,
        },
        {
            name: '澄清醫院-中港分院(本院)',
            city: '臺中市',
            district: '西屯區',
            address: '臺中市西屯區臺灣大道4段966號',
            latitude: '24.18285',
            longitude: '120.617',
            order: true,
        },
        {
            name: '澄清醫院-中港分院(門診中心)',
            city: '臺中市',
            district: '西屯區',
            address: '臺中市西屯區敬德街8-1號',
            latitude: '24.19931',
            longitude: '120.6122',
            order: true,
        },
        {
            name: '澄清醫院-中港分院(敬義樓)',
            city: '臺中市',
            district: '西屯區',
            address: '臺中市西屯區福林里2鄰福康路8號',
            latitude: '24.18337',
            longitude: '120.6169',
            order: true,
        },
        {
            name: '臺中仁愛醫院',
            city: '臺中市',
            district: '中區',
            address: '臺中市中區柳川里柳川東路三段36號',
            latitude: '24.14336',
            longitude: '120.6779',
            order: true,
        },
        {
            name: '第一醫院',
            city: '臺中市',
            district: '中區',
            address: '臺中市中區民族路184號',
            latitude: '24.1425',
            longitude: '120.6764',
            order: true,
        },
        {
            name: '澄清醫院',
            city: '臺中市',
            district: '中區',
            address: '臺中市中區平等街139號',
            latitude: '24.1426',
            longitude: '120.6816',
            order: true,
        },
        {
            name: '臺南市立安南醫院',
            city: '臺南市',
            district: '安南區',
            address: '臺南市安南區長和路二段66號',
            latitude: '23.06423',
            longitude: '120.2232',
            order: true,
        },
        {
            name: '佑昇醫院',
            city: '臺南市',
            district: '白河區',
            address: '臺南市白河區民安路1號',
            latitude: '23.34629',
            longitude: '120.4112',
            order: true,
        },
        {
            name: '成大醫院',
            city: '臺南市',
            district: '北區',
            address: '臺南市北區勝利路138號',
            latitude: '23.00221',
            longitude: '120.2192',
            order: true,
        },
        {
            name: '陳澤彥婦產科醫院',
            city: '臺南市',
            district: '北區',
            address: '臺南市北區中華北路二段101號',
            latitude: '23.01978',
            longitude: '120.1984',
            order: true,
        },
        {
            name: '志誠醫院',
            city: '臺南市',
            district: '北區',
            address: '臺南市北區興南里公園路315-1號',
            latitude: '23.0036',
            longitude: '120.21',
            order: true,
        },
        {
            name: '開元寺慈愛醫院',
            city: '臺南市',
            district: '北區',
            address: '臺南市北區北園街89-1號',
            latitude: '23.01073',
            longitude: '120.2229',
            order: true,
        },
        {
            name: '美德中醫醫院',
            city: '臺南市',
            district: '北區',
            address: '臺南市北區公園路661號',
            latitude: '23.01599',
            longitude: '120.2139',
            order: true,
        },
        {
            name: '衛福部胸腔病院-大同院區',
            city: '臺南市',
            district: '東區',
            address: '臺南市東區大同路一段69號',
            latitude: '22.98719',
            longitude: '120.2115',
            order: true,
        },
        {
            name: '仁愛醫院',
            city: '臺南市',
            district: '東區',
            address: '臺南市東區北門路一段10號',
            latitude: '22.98977',
            longitude: '120.2116',
            order: true,
        },
        {
            name: '臺南市立醫院',
            city: '臺南市',
            district: '東區',
            address: '臺南市東區崇德路670號',
            latitude: '22.96854',
            longitude: '120.2267',
            order: true,
        },
        {
            name: '臺南新樓醫院',
            city: '臺南市',
            district: '東區',
            address: '臺南市東區東門路1段57號',
            latitude: '22.98916',
            longitude: '120.2128',
            order: true,
        },
        {
            name: '吉安醫院',
            city: '臺南市',
            district: '關廟區',
            address: '臺南市關廟區中正路435號',
            latitude: '22.96705',
            longitude: '120.3443',
            order: true,
        },
        {
            name: '佳里奇美醫院',
            city: '臺南市',
            district: '佳里區',
            address: '臺南市佳里區興化里606號',
            latitude: '23.182242',
            longitude: '120.183914',
            order: true,
        },
        {
            name: '新生醫院',
            city: '臺南市',
            district: '佳里區',
            address: '臺南市佳里區新生路272號',
            latitude: '23.16045',
            longitude: '120.1765',
            order: true,
        },
        {
            name: '柳營奇美醫院',
            city: '臺南市',
            district: '柳營區',
            address: '臺南市柳營區太康里201號',
            latitude: '23.289525',
            longitude: '120.32501',
            order: true,
        },
        {
            name: '麻豆新樓醫院',
            city: '臺南市',
            district: '麻豆區',
            address: '臺南市麻豆區埤頭里苓子林20號',
            latitude: '23.180512',
            longitude: '120.232876',
            order: true,
        },
        {
            name: '奇美醫院-臺南分院',
            city: '臺南市',
            district: '南區',
            address: '臺南市南區樹林街2段442號',
            latitude: '22.98658',
            longitude: '120.1961',
            order: true,
        },
        {
            name: '奇美醫院-樹林院區',
            city: '臺南市',
            district: '南區',
            address: '臺南市南區樹林街二段442號',
            latitude: '22.98658',
            longitude: '120.1961',
            order: true,
        },
        {
            name: '衛福部胸腔病院-本院',
            city: '臺南市',
            district: '仁德區',
            address: '臺南市仁德區中山路864號',
            latitude: '22.97546',
            longitude: '120.2418',
            order: true,
        },
        {
            name: '衛福部嘉南療養院',
            city: '臺南市',
            district: '仁德區',
            address: '臺南市仁德區裕忠路539號',
            latitude: '22.97672',
            longitude: '120.242',
            order: true,
        },
        {
            name: '宏科醫院',
            city: '臺南市',
            district: '善化區',
            address: '臺南市善化區三民路1-35號',
            latitude: '23.12753',
            longitude: '120.287',
            order: true,
        },
        {
            name: '衛福部臺南醫院-新化分院',
            city: '臺南市',
            district: '新化區',
            address: '臺南市新化區那拔里牧場72號',
            latitude: '23.06339',
            longitude: '120.336169',
            order: true,
        },
        {
            name: '私立臺南仁愛之家-精神療養院',
            city: '臺南市',
            district: '新化區',
            address: '臺南市新化區中山路20號',
            latitude: '23.0511',
            longitude: '120.3197',
            order: true,
        },
        {
            name: '衛福部新營醫院',
            city: '臺南市',
            district: '新營區',
            address: '臺南市新營區信義街73號',
            latitude: '23.309091',
            longitude: '120.31373',
            order: true,
        },
        {
            name: '新興醫院',
            city: '臺南市',
            district: '新營區',
            address: '臺南市新營區中興路10號',
            latitude: '23.30364',
            longitude: '120.3169',
            order: true,
        },
        {
            name: '營新醫院',
            city: '臺南市',
            district: '新營區',
            address: '臺南市新營區隋唐街228號',
            latitude: '23.30839',
            longitude: '120.2998',
            order: true,
        },
        {
            name: '信一骨科醫院',
            city: '臺南市',
            district: '新營區',
            address: '臺南市新營區民生路43-26號',
            latitude: '23.30622',
            longitude: '120.3077',
            order: true,
        },
        {
            name: '高雄榮民總醫院-臺南分院',
            city: '臺南市',
            district: '永康區',
            address: '臺南市永康區復興路427號',
            latitude: '22.99722',
            longitude: '120.2403',
            order: true,
        },
        {
            name: '永達醫院',
            city: '臺南市',
            district: '永康區',
            address: '臺南市永康區永大路二段1326號',
            latitude: '23.02221',
            longitude: '120.2615',
            order: true,
        },
        {
            name: '晉生慢性醫院',
            city: '臺南市',
            district: '永康區',
            address: '臺南市永康區中山南路902巷5號',
            latitude: '23.02137',
            longitude: '120.2491',
            order: true,
        },
        {
            name: '奇美醫院-本院',
            city: '臺南市',
            district: '永康區',
            address: '臺南市永康區中華路901號',
            latitude: '23.02061',
            longitude: '120.2219',
            order: true,
        },
        {
            name: '璟馨婦幼醫院',
            city: '臺南市',
            district: '永康區',
            address: '臺南市永康區東橋里東橋七路198號',
            latitude: '23.0212',
            longitude: '120.2372',
            order: true,
        },
        {
            name: '衛福部臺南醫院',
            city: '臺南市',
            district: '中西區',
            address: '臺南市中西區中山路125號',
            latitude: '22.99582',
            longitude: '120.2092',
            order: true,
        },
        {
            name: '大安婦幼醫院',
            city: '臺南市',
            district: '中西區',
            address: '臺南市中西區金華路三段167號',
            latitude: '22.99307',
            longitude: '120.193',
            order: true,
        },
        {
            name: '洪外科醫院',
            city: '臺南市',
            district: '中西區',
            address: '臺南市中西區民生路2段60號',
            latitude: '22.99513',
            longitude: '120.1976',
            order: true,
        },
        {
            name: '郭綜合醫院',
            city: '臺南市',
            district: '中西區',
            address: '臺南市中西區民生路二段22號',
            latitude: '22.99486',
            longitude: '120.1985',
            order: true,
        },
        {
            name: '永川醫院',
            city: '臺南市',
            district: '中西區',
            address: '臺南市中西區成功路169號',
            latitude: '22.99803',
            longitude: '120.2063',
            order: true,
        },
        {
            name: '永和醫院',
            city: '臺南市',
            district: '中西區',
            address: '臺南市中西區府前路一段304巷2號',
            latitude: '22.99047',
            longitude: '120.1991',
            order: true,
        },
        {
            name: '仁村醫院',
            city: '臺南市',
            district: '中西區',
            address: '臺南市中西區西門路一段486號',
            latitude: '22.98363',
            longitude: '120.1977',
            order: true,
        },
        {
            name: '長佑醫院',
            city: '高雄市',
            district: '阿蓮區',
            address: '高雄市阿蓮區中山路150號',
            latitude: '22.87758',
            longitude: '120.3277',
            order: true,
        },
        {
            name: '慈惠精神醫院',
            city: '高雄市',
            district: '大寮區',
            address: '高雄市大寮區鳳屏一路509號',
            latitude: '22.63924',
            longitude: '120.3975',
            order: true,
        },
        {
            name: '樂生婦幼醫院',
            city: '高雄市',
            district: '大寮區',
            address: '高雄市大寮區鳳林三路532號',
            latitude: '22.60682',
            longitude: '120.3956',
            order: true,
        },
        {
            name: '瑞生醫院',
            city: '高雄市',
            district: '大寮區',
            address: '高雄市大寮區鳳林四路192號',
            latitude: '22.61769',
            longitude: '120.3849',
            order: true,
        },
        {
            name: '高雄市立鳳山醫院',
            city: '高雄市',
            district: '鳳山區',
            address: '高雄市鳳山區經武路42號',
            latitude: '22.62856',
            longitude: '120.3631',
            order: true,
        },
        {
            name: '新高鳳醫院',
            city: '高雄市',
            district: '鳳山區',
            address: '高雄市鳳山區光遠路360號',
            latitude: '22.62621',
            longitude: '120.3588',
            order: true,
        },
        {
            name: '大東醫院',
            city: '高雄市',
            district: '鳳山區',
            address: '高雄市鳳山區光遠路171-2號',
            latitude: '22.62536',
            longitude: '120.362',
            order: true,
        },
        {
            name: '優生婦產科醫院',
            city: '高雄市',
            district: '鳳山區',
            address: '高雄市鳳山區自由路189號',
            latitude: '22.62557',
            longitude: '120.351',
            order: true,
        },
        {
            name: '惠德醫院',
            city: '高雄市',
            district: '鳳山區',
            address: '高雄市鳳山區福祥街81號',
            latitude: '22.59203',
            longitude: '120.3251',
            order: true,
        },
        {
            name: '仁惠婦幼醫院',
            city: '高雄市',
            district: '鳳山區',
            address: '高雄市鳳山區自由路81號',
            latitude: '22.62581',
            longitude: '120.3534',
            order: true,
        },
        {
            name: '杏和醫院',
            city: '高雄市',
            district: '鳳山區',
            address: '高雄市鳳山區五甲二路389號',
            latitude: '22.59764',
            longitude: '120.3356',
            order: true,
        },
        {
            name: '國軍高雄總醫院-岡山分院',
            city: '高雄市',
            district: '岡山區',
            address: '高雄市岡山區大義二路1號',
            latitude: '22.78946',
            longitude: '120.2859',
            order: true,
        },
        {
            name: '高雄市立岡山醫院',
            city: '高雄市',
            district: '岡山區',
            address: '高雄市岡山區壽天路12號',
            latitude: '22.79661',
            longitude: '120.2944',
            order: true,
        },
        {
            name: '劉嘉修醫院',
            city: '高雄市',
            district: '岡山區',
            address: '高雄市岡山區岡山路428號',
            latitude: '22.79576',
            longitude: '120.2959',
            order: true,
        },
        {
            name: '光雄長安醫院',
            city: '高雄市',
            district: '岡山區',
            address: '高雄市岡山區岡山路380-1號',
            latitude: '22.79425',
            longitude: '120.296',
            order: true,
        },
        {
            name: '樂安醫院',
            city: '高雄市',
            district: '岡山區',
            address: '高雄市岡山區通校路300號',
            latitude: '22.79245',
            longitude: '120.2812',
            order: true,
        },
        {
            name: '惠川醫院',
            city: '高雄市',
            district: '岡山區',
            address: '高雄市岡山區岡山路92號',
            latitude: '22.78799',
            longitude: '120.2968',
            order: true,
        },
        {
            name: '高雄市立聯合醫院',
            city: '高雄市',
            district: '鼓山區',
            address: '高雄市鼓山區中華一路976號',
            latitude: '22.65502',
            longitude: '120.2917',
            order: true,
        },
        {
            name: '正大醫院',
            city: '高雄市',
            district: '鼓山區',
            address: '高雄市鼓山區鼓山三路128號',
            latitude: '22.66364',
            longitude: '120.2793',
            order: true,
        },
        {
            name: '生安婦產小兒科醫院',
            city: '高雄市',
            district: '鼓山區',
            address: '高雄市鼓山區美術東二路177號',
            latitude: '22.66232',
            longitude: '120.2883',
            order: true,
        },
        {
            name: '建佑醫院',
            city: '高雄市',
            district: '林園區',
            address: '高雄市林園區東林西路358號',
            latitude: '22.50384',
            longitude: '120.3867',
            order: true,
        },
        {
            name: '霖園醫院',
            city: '高雄市',
            district: '林園區',
            address: '高雄市林園區林園北路244號',
            latitude: '22.509196',
            longitude: '120.395025',
            order: true,
        },
        {
            name: '高雄市立民生醫院',
            city: '高雄市',
            district: '苓雅區',
            address: '高雄市苓雅區凱旋二路134號',
            latitude: '22.62649',
            longitude: '120.3237',
            order: true,
        },
        {
            name: '高雄市立凱旋醫院',
            city: '高雄市',
            district: '苓雅區',
            address: '高雄市苓雅區凱旋二路130號',
            latitude: '22.62519',
            longitude: '120.3243',
            order: true,
        },
        {
            name: '國軍高雄總醫院',
            city: '高雄市',
            district: '苓雅區',
            address: '高雄市苓雅區建軍路5號',
            latitude: '22.62705',
            longitude: '120.342',
            order: true,
        },
        {
            name: '阮綜合醫院',
            city: '高雄市',
            district: '苓雅區',
            address: '高雄市苓雅區成功一路156號',
            latitude: '22.61542',
            longitude: '120.2974',
            order: true,
        },
        {
            name: '乃榮醫院',
            city: '高雄市',
            district: '苓雅區',
            address: '高雄市苓雅區三多二路226號',
            latitude: '22.61886',
            longitude: '120.319',
            order: true,
        },
        {
            name: '天主教聖功醫院',
            city: '高雄市',
            district: '苓雅區',
            address: '高雄市苓雅區建國一路352號',
            latitude: '22.63312',
            longitude: '120.3239',
            order: true,
        },
        {
            name: '高雄基督教醫院',
            city: '高雄市',
            district: '苓雅區',
            address: '高雄市苓雅區華新街86號',
            latitude: '22.61397',
            longitude: '120.2964',
            order: true,
        },
        {
            name: '邱外科醫院',
            city: '高雄市',
            district: '苓雅區',
            address: '高雄市苓雅區成功一路137號',
            latitude: '22.61466',
            longitude: '120.2973',
            order: true,
        },
        {
            name: '溫有諒醫院',
            city: '高雄市',
            district: '路竹區',
            address: '高雄市路竹區延平路57號',
            latitude: '22.85797',
            longitude: '120.2587',
            order: true,
        },
        {
            name: '高新醫院',
            city: '高雄市',
            district: '路竹區',
            address: '高雄市路竹區中山路627號',
            latitude: '22.86546',
            longitude: '120.2572',
            order: true,
        },
        {
            name: '三聖醫院',
            city: '高雄市',
            district: '美濃區',
            address: '高雄市美濃區合和里合和路56號',
            latitude: '22.89401',
            longitude: '120.5481',
            order: true,
        },
        {
            name: '健仁醫院',
            city: '高雄市',
            district: '楠梓區',
            address: '高雄市楠梓區楠陽路136號',
            latitude: '22.72362',
            longitude: '120.329',
            order: true,
        },
        {
            name: '顏威裕醫院',
            city: '高雄市',
            district: '楠梓區',
            address: '高雄市楠梓區後昌路826號',
            latitude: '22.71117',
            longitude: '120.2957',
            order: true,
        },
        {
            name: '長春醫院',
            city: '高雄市',
            district: '楠梓區',
            address: '高雄市楠梓區右昌街331號',
            latitude: '22.71427',
            longitude: '120.2891',
            order: true,
        },
        {
            name: '右昌聯合醫院',
            city: '高雄市',
            district: '楠梓區',
            address: '高雄市楠梓區軍校路930號',
            latitude: '22.7138',
            longitude: '120.2909',
            order: true,
        },
        {
            name: '金安心醫院',
            city: '高雄市',
            district: '楠梓區',
            address: '高雄市楠梓區加昌路606號',
            latitude: '22.71588',
            longitude: '120.299',
            order: true,
        },
        {
            name: '高雄長庚醫院',
            city: '高雄市',
            district: '鳥松區',
            address: '高雄市鳥松區大埤路123號',
            latitude: '22.64985',
            longitude: '120.356',
            order: true,
        },
        {
            name: '高雄市立旗津醫院',
            city: '高雄市',
            district: '旗津區',
            address: '高雄市旗津區旗港路33號',
            latitude: '22.59021',
            longitude: '120.2851',
            order: true,
        },
        {
            name: '衛福部旗山醫院',
            city: '高雄市',
            district: '旗山區',
            address: '高雄市旗山區中學路60號',
            latitude: '22.88069',
            longitude: '120.4833',
            order: true,
        },
        {
            name: '廣聖醫院',
            city: '高雄市',
            district: '旗山區',
            address: '高雄市旗山區中華路618號',
            latitude: '22.88498',
            longitude: '120.4854',
            order: true,
        },
        {
            name: '重安醫院',
            city: '高雄市',
            district: '旗山區',
            address: '高雄市旗山區大仁街14號',
            latitude: '22.88295',
            longitude: '120.4848',
            order: true,
        },
        {
            name: '溪洲醫院',
            city: '高雄市',
            district: '旗山區',
            address: '高雄市旗山區延平一路408號',
            latitude: '22.89293',
            longitude: '120.4832',
            order: true,
        },
        {
            name: '高雄市立大同醫院',
            city: '高雄市',
            district: '前金區',
            address: '高雄市前金區中華三路68號',
            latitude: '22.62699',
            longitude: '120.2972',
            order: true,
        },
        {
            name: '高雄市立中醫醫院',
            city: '高雄市',
            district: '苓雅區',
            address: '高雄市苓雅區凱旋二路132號',
            latitude: '22.62699',
            longitude: '120.2972',
            order: true,
        },
        {
            name: '重仁骨科醫院',
            city: '高雄市',
            district: '前金區',
            address: '高雄市前金區中華三路247號',
            latitude: '22.63436',
            longitude: '120.2937',
            order: true,
        },
        {
            name: '健新醫院',
            city: '高雄市',
            district: '前金區',
            address: '高雄市前金區七賢二路295號',
            latitude: '22.63132',
            longitude: '120.2908',
            order: true,
        },
        {
            name: '中正脊椎骨科醫院',
            city: '高雄市',
            district: '前金區',
            address: '高雄市前金區中正四路99號',
            latitude: '22.62992',
            longitude: '120.2982',
            order: true,
        },
        {
            name: '上琳醫院',
            city: '高雄市',
            district: '前金區',
            address: '高雄市前金區自強一路67號',
            latitude: '22.6312',
            longitude: '120.2928',
            order: true,
        },
        {
            name: '活力得中山脊椎外科醫院',
            city: '高雄市',
            district: '前金區',
            address: '高雄市前金區青年二路6號',
            latitude: '22.62005',
            longitude: '120.3017',
            order: true,
        },
        {
            name: '吳昆哲婦產小兒科醫院',
            city: '高雄市',
            district: '前鎮區',
            address: '高雄市前鎮區民權二路430號',
            latitude: '22.61208',
            longitude: '120.3144',
            order: true,
        },
        {
            name: '佳欣婦幼醫院',
            city: '高雄市',
            district: '前鎮區',
            address: '高雄市前鎮區三多三路149號',
            latitude: '22.61565',
            longitude: '120.3102',
            order: true,
        },
        {
            name: '瑞祥醫院',
            city: '高雄市',
            district: '前鎮區',
            address: '高雄市前鎮區班超路92號',
            latitude: '22.60263',
            longitude: '120.3249',
            order: true,
        },
        {
            name: '新正薪醫院',
            city: '高雄市',
            district: '前鎮區',
            address: '高雄市前鎮區一心一路233號',
            latitude: '22.60787',
            longitude: '120.3176',
            order: true,
        },
        {
            name: '泰和醫院',
            city: '高雄市',
            district: '橋頭區',
            address: '高雄市橋頭區成功路101號',
            latitude: '22.75876',
            longitude: '120.3096',
            order: true,
        },
        {
            name: '愛仁醫院',
            city: '高雄市',
            district: '三民區',
            address: '高雄市三民區民族一路45號',
            latitude: '22.64168',
            longitude: '120.3138',
            order: true,
        },
        {
            name: '義大大昌醫院',
            city: '高雄市',
            district: '三民區',
            address: '高雄市三民區大昌一路305號',
            latitude: '22.65758',
            longitude: '120.3199',
            order: true,
        },
        {
            name: '高雄醫學大學附設中和紀念醫院',
            city: '高雄市',
            district: '三民區',
            address: '高雄市三民區十全一路100號',
            latitude: '22.64518',
            longitude: '120.31',
            order: true,
        },
        {
            name: '德謙醫院',
            city: '高雄市',
            district: '三民區',
            address: '高雄市三民區九如二路18號',
            latitude: '22.64067',
            longitude: '120.3132',
            order: true,
        },
        {
            name: '南山醫院',
            city: '高雄市',
            district: '三民區',
            address: '高雄市三民區建國三路151號',
            latitude: '22.637991',
            longitude: '120.299093',
            order: true,
        },
        {
            name: '祐生醫院',
            city: '高雄市',
            district: '三民區',
            address: '高雄市三民區建國三路60號',
            latitude: '22.63798',
            longitude: '120.2961',
            order: true,
        },
        {
            name: '民族醫院',
            city: '高雄市',
            district: '三民區',
            address: '高雄市三民區民族一路880號',
            latitude: '22.66855',
            longitude: '120.3175',
            order: true,
        },
        {
            name: '文雄醫院',
            city: '高雄市',
            district: '三民區',
            address: '高雄市三民區察哈爾二街132號',
            latitude: '22.64805',
            longitude: '120.2996',
            order: true,
        },
        {
            name: '謝外科醫院',
            city: '高雄市',
            district: '三民區',
            address: '高雄市三民區河北一路330號',
            latitude: '22.63684',
            longitude: '120.3032',
            order: true,
        },
        {
            name: '四季臺安醫院',
            city: '高雄市',
            district: '三民區',
            address: '高雄市三民區聯興路157號',
            latitude: '22.65945',
            longitude: '120.3138',
            order: true,
        },
        {
            name: '新高醫院',
            city: '高雄市',
            district: '三民區',
            address: '高雄市三民區莊敬路288號',
            latitude: '22.64999',
            longitude: '120.3183',
            order: true,
        },
        {
            name: '高雄市立小港醫院',
            city: '高雄市',
            district: '小港區',
            address: '高雄市小港區山明里山明路482號',
            latitude: '22.56747',
            longitude: '120.3634',
            order: true,
        },
        {
            name: '安泰醫院',
            city: '高雄市',
            district: '小港區',
            address: '高雄市小港區學府路111號',
            latitude: '22.56523',
            longitude: '120.3614',
            order: true,
        },
        {
            name: '戴銘浚婦兒醫院',
            city: '高雄市',
            district: '小港區',
            address: '高雄市小港區宏平路正苓里661號',
            latitude: '22.56957',
            longitude: '120.3512',
            order: true,
        },
        {
            name: '蕭志文醫院',
            city: '高雄市',
            district: '新興區',
            address: '高雄市新興區七賢一路102號',
            latitude: '22.63394',
            longitude: '120.3143',
            order: true,
        },
        {
            name: '靜和醫院',
            city: '高雄市',
            district: '新興區',
            address: '高雄市新興區民族二路176號',
            latitude: '22.63614',
            longitude: '120.3141',
            order: true,
        },
        {
            name: '原祿骨科醫院',
            city: '高雄市',
            district: '新興區',
            address: '高雄市新興區中正三路52號',
            latitude: '22.63112',
            longitude: '120.3091',
            order: true,
        },
        {
            name: '惠仁醫院',
            city: '高雄市',
            district: '新興區',
            address: '高雄市新興區中山一路67-2號',
            latitude: '22.62986',
            longitude: '120.3015',
            order: true,
        },
        {
            name: '新華醫院',
            city: '高雄市',
            district: '新興區',
            address: '高雄市新興區七賢二路97號',
            latitude: '22.63385',
            longitude: '120.2984',
            order: true,
        },
        {
            name: '七賢脊椎外科醫院',
            city: '高雄市',
            district: '新興區',
            address: '高雄市新興區七賢一路420號',
            latitude: '22.63451',
            longitude: '120.3061',
            order: true,
        },
        {
            name: '燕巢靜和醫院',
            city: '高雄市',
            district: '燕巢區',
            address: '高雄市燕巢區深水里深水路3之20號',
            latitude: '22.78165',
            longitude: '120.4167',
            order: true,
        },
        {
            name: '義大癌治療醫院',
            city: '高雄市',
            district: '燕巢區',
            address: '高雄市燕巢區角宿里義大路21號',
            latitude: '22.7657',
            longitude: '120.3652',
            order: true,
        },
        {
            name: '義大醫院',
            city: '高雄市',
            district: '燕巢區',
            address: '高雄市燕巢區角宿里義大路1號',
            latitude: '22.76552',
            longitude: '120.3645',
            order: true,
        },
        {
            name: '國軍高雄總醫院-左營分院',
            city: '高雄市',
            district: '左營區',
            address: '高雄市左營區軍校路553號',
            latitude: '22.70035',
            longitude: '120.2922',
            order: true,
        },
        {
            name: '高雄榮民總醫院',
            city: '高雄市',
            district: '左營區',
            address: '高雄市左營區大中一路386號',
            latitude: '22.6777',
            longitude: '120.3223',
            order: true,
        },
        {
            name: '馨蕙馨醫院',
            city: '高雄市',
            district: '左營區',
            address: '高雄市左營區明誠二路541號',
            latitude: '22.66097',
            longitude: '120.3038',
            order: true,
        },
        {
            name: '柏仁醫院',
            city: '高雄市',
            district: '左營區',
            address: '高雄市左營區博愛二路350號',
            latitude: '22.66434',
            longitude: '120.3036',
            order: true,
        },
        {
            name: '博愛蕙馨醫院',
            city: '高雄市',
            district: '左營區',
            address: '高雄市左營區博愛二路20號',
            latitude: '22.65683',
            longitude: '120.3035',
            order: true,
        },
        {
            name: '博正醫院',
            city: '高雄市',
            district: '左營區',
            address: '高雄市左營區博愛二路100號',
            latitude: '22.65813',
            longitude: '120.3034',
            order: true,
        },
        {
            name: '南星醫院',
            city: '彰化縣',
            district: '北斗鎮',
            address: '彰化縣北斗鎮斗苑路一段26號',
            latitude: '23.8725',
            longitude: '120.5277',
            order: true,
        },
        {
            name: '卓醫院',
            city: '彰化縣',
            district: '北斗鎮',
            address: '彰化縣北斗鎮中山路一段311號',
            latitude: '23.87228',
            longitude: '120.5155',
            order: true,
        },
        {
            name: '衛福部彰化醫院',
            city: '彰化縣',
            district: '埔心鄉',
            address: '彰化縣埔心鄉中正路二段80號',
            latitude: '23.95023',
            longitude: '120.5273',
            order: true,
        },
        {
            name: '員林郭醫院-大村分院',
            city: '彰化縣',
            district: '大村鄉',
            address: '彰化縣大村鄉田洋橫巷2-9號',
            latitude: '23.999325',
            longitude: '120.538968',
            order: true,
        },
        {
            name: '洪宗鄰醫院',
            city: '彰化縣',
            district: '二林鎮',
            address: '彰化縣二林鎮中正路61號',
            latitude: '23.89891',
            longitude: '120.3679',
            order: true,
        },
        {
            name: '二林基督教醫院',
            city: '彰化縣',
            district: '二林鎮',
            address: '彰化縣二林鎮南光里大成路一段558號',
            latitude: '23.89361',
            longitude: '120.3633',
            order: true,
        },
        {
            name: '宋志懿醫院',
            city: '彰化縣',
            district: '二林鎮',
            address: '彰化縣二林鎮大成路一段51號',
            latitude: '23.90064',
            longitude: '120.3728',
            order: true,
        },
        {
            name: '道周醫院',
            city: '彰化縣',
            district: '和美鎮',
            address: '彰化縣和美鎮和光路180號',
            latitude: '24.11057',
            longitude: '120.4919',
            order: true,
        },
        {
            name: '彰濱秀傳醫院',
            city: '彰化縣',
            district: '鹿港鎮',
            address: '彰化縣鹿港鎮鹿工路6號',
            latitude: '24.07827',
            longitude: '120.4111',
            order: true,
        },
        {
            name: '鹿港基督教醫院-本院',
            city: '彰化縣',
            district: '鹿港鎮',
            address: '彰化縣鹿港鎮中正路480號',
            latitude: '24.06038',
            longitude: '120.4382',
            order: true,
        },
        {
            name: '鹿港基督教醫院-長青院區',
            city: '彰化縣',
            district: '鹿港鎮',
            address: '彰化縣彰化縣鹿港鎮鹿東路二段888號',
            latitude: '24.055542',
            longitude: '120.468825',
            order: true,
        },
        {
            name: '伸港忠孝醫院',
            city: '彰化縣',
            district: '伸港鄉',
            address: '彰化縣伸港鄉新港村忠孝路30號',
            latitude: '24.14865',
            longitude: '120.4858',
            order: true,
        },
        {
            name: '仁和醫院',
            city: '彰化縣',
            district: '田中鎮',
            address: '彰化縣田中鎮中州路一段157號',
            latitude: '23.85802',
            longitude: '120.5879',
            order: true,
        },
        {
            name: '建元醫院',
            city: '彰化縣',
            district: '田中鎮',
            address: '彰化縣田中鎮中路里中南路三段512號',
            latitude: '23.85336',
            longitude: '120.5904',
            order: true,
        },
        {
            name: '道安醫院',
            city: '彰化縣',
            district: '溪湖鎮',
            address: '彰化縣溪湖鎮光平里彰水路3段362號',
            latitude: '23.96154',
            longitude: '120.4802',
            order: true,
        },
        {
            name: '員榮醫院',
            city: '彰化縣',
            district: '員林鎮',
            address: '彰化縣員林市中正路201號',
            latitude: '23.95365',
            longitude: '120.5748',
            order: true,
        },
        {
            name: '惠來宏仁醫院',
            city: '彰化縣',
            district: '員林鎮',
            address: '彰化縣員林市惠來里惠來街89號',
            latitude: '23.95527',
            longitude: '120.5703',
            order: true,
        },
        {
            name: '員林基督教醫院',
            city: '彰化縣',
            district: '員林鎮',
            address: '彰化縣員林市南平里莒光路456號',
            latitude: '23.96275',
            longitude: '120.567',
            order: true,
        },
        {
            name: '員林何醫院',
            city: '彰化縣',
            district: '員林鎮',
            address: '彰化縣員林市民族街33號',
            latitude: '23.95715',
            longitude: '120.5705',
            order: true,
        },
        {
            name: '敦仁醫院',
            city: '彰化縣',
            district: '員林鎮',
            address: '彰化縣員林市員水路一段102巷74弄99號',
            latitude: '23.95147',
            longitude: '120.6047',
            order: true,
        },
        {
            name: '皓生醫院',
            city: '彰化縣',
            district: '員林鎮',
            address: '彰化縣員林市萬年路3段133號',
            latitude: '23.95916',
            longitude: '120.5735',
            order: true,
        },
        {
            name: '員生醫院',
            city: '彰化縣',
            district: '員林鎮',
            address: '彰化縣員林市莒光路359號',
            latitude: '23.95925',
            longitude: '120.5664',
            order: true,
        },
        {
            name: '員郭醫院',
            city: '彰化縣',
            district: '員林鎮',
            address: '彰化縣員林市南興里1鄰員林大道六段51號',
            latitude: '23.96747',
            longitude: '120.5627',
            order: true,
        },
        {
            name: '秀傳醫院',
            city: '彰化縣',
            district: '彰化市',
            address: '彰化縣彰化市中山路一段542號',
            latitude: '24.06479',
            longitude: '120.5375',
            order: true,
        },
        {
            name: '彰化基督教醫院',
            city: '彰化縣',
            district: '彰化市',
            address: '彰化縣彰化市南校街135號',
            latitude: '24.07149',
            longitude: '120.5445',
            order: true,
        },
        {
            name: '彰化基督教兒童醫院',
            city: '彰化縣',
            district: '彰化市',
            address: '彰化縣彰化市光南里13鄰旭光路320號',
            latitude: '24.07117',
            longitude: '120.5435',
            order: true,
        },
        {
            name: '信生醫院',
            city: '彰化縣',
            district: '彰化市',
            address: '彰化縣彰化市三民路312號',
            latitude: '24.08577',
            longitude: '120.545',
            order: true,
        },
        {
            name: '漢銘醫院',
            city: '彰化縣',
            district: '彰化市',
            address: '彰化縣彰化市南興里中山路一段366號',
            latitude: '24.0613',
            longitude: '120.5358',
            order: true,
        },
        {
            name: '冠華醫院',
            city: '彰化縣',
            district: '彰化市',
            address: '彰化縣彰化市光復里中正路一段437號',
            latitude: '24.08248',
            longitude: '120.5428',
            order: true,
        },
        {
            name: '成美醫院',
            city: '彰化縣',
            district: '彰化市',
            address: '彰化縣彰化市三民路56號',
            latitude: '24.08315',
            longitude: '120.5404',
            order: true,
        },
        {
            name: '順安醫院',
            city: '彰化縣',
            district: '彰化市',
            address: '彰化縣彰化市光復路53號',
            latitude: '24.08071',
            longitude: '120.544',
            order: true,
        },
        {
            name: '明德醫院',
            city: '彰化縣',
            district: '彰化市',
            address: '彰化縣彰化市龍山里中山路二段874巷33號',
            latitude: '24.08142',
            longitude: '120.553',
            order: true,
        },
        {
            name: '中國醫藥大學北港附設醫院',
            city: '雲林縣',
            district: '北港鎮',
            address: '雲林縣北港鎮新德路123號',
            latitude: '23.59176',
            longitude: '120.3078',
            order: true,
        },
        {
            name: '全生醫院',
            city: '雲林縣',
            district: '北港鎮',
            address: '雲林縣雲林縣北港鎮中正路100號',
            latitude: '23.570205',
            longitude: '120.30165',
            order: true,
        },
        {
            name: '諸元內科醫院',
            city: '雲林縣',
            district: '北港鎮',
            address: '雲林縣北港鎮中和里中山路125號',
            latitude: '23.567297',
            longitude: '120.304843',
            order: true,
        },
        {
            name: '北港仁一醫院',
            city: '雲林縣',
            district: '北港鎮',
            address: '雲林縣北港鎮公園路155號',
            latitude: '23.5774',
            longitude: '120.3012',
            order: true,
        },
        {
            name: '臺大醫院-雲林分院(本院)',
            city: '雲林縣',
            district: '斗六市',
            address: '雲林縣斗六市雲林路二段579號',
            latitude: '23.69766',
            longitude: '120.5259',
            order: true,
        },
        {
            name: '成大醫院-斗六分院',
            city: '雲林縣',
            district: '斗六市',
            address: '雲林縣斗六市莊敬路345號',
            latitude: '23.70313',
            longitude: '120.5456',
            order: true,
        },
        {
            name: '信安醫院',
            city: '雲林縣',
            district: '斗六市',
            address: '雲林縣斗六市江厝里瓦厝路159號',
            latitude: '23.66864',
            longitude: '120.5113',
            order: true,
        },
        {
            name: '斗六慈濟醫院',
            city: '雲林縣',
            district: '斗六市',
            address: '雲林縣斗六市雲林路二段248號',
            latitude: '23.70228',
            longitude: '120.53',
            order: true,
        },
        {
            name: '洪揚醫院',
            city: '雲林縣',
            district: '斗六市',
            address: '雲林縣斗六市忠孝里文化路138號',
            latitude: '23.71087',
            longitude: '120.5488',
            order: true,
        },
        {
            name: '安生醫院',
            city: '雲林縣',
            district: '斗六市',
            address: '雲林縣斗六市仁愛里永樂街120號',
            latitude: '23.70833',
            longitude: '120.547',
            order: true,
        },
        {
            name: '天主教福安醫院',
            city: '雲林縣',
            district: '斗南鎮',
            address: '雲林縣斗南鎮北銘里文昌路110號',
            latitude: '23.67877',
            longitude: '120.4821',
            order: true,
        },
        {
            name: '臺大醫院-雲林分院(虎尾院區)',
            city: '雲林縣',
            district: '虎尾鎮',
            address: '雲林縣虎尾鎮廉使里學府路95號',
            latitude: '23.73666',
            longitude: '120.4233',
            order: true,
        },
        {
            name: '若瑟醫院',
            city: '雲林縣',
            district: '虎尾鎮',
            address: '雲林縣虎尾鎮新生路74號',
            latitude: '23.70822',
            longitude: '120.4379',
            order: true,
        },
        {
            name: '雲林長庚紀念醫院',
            city: '雲林縣',
            district: '麥寮鄉',
            address: '雲林縣麥寮鄉中興村工業路1500號',
            latitude: '23.79518',
            longitude: '120.2183',
            order: true,
        },
        {
            name: '蔡醫院',
            city: '雲林縣',
            district: '土庫鎮',
            address: '雲林縣土庫鎮中山路64號',
            latitude: '23.67446',
            longitude: '120.39',
            order: true,
        },
        {
            name: '雲林基督教醫院',
            city: '雲林縣',
            district: '西螺鎮',
            address: '雲林縣西螺鎮新豐里市場南路375號',
            latitude: '23.78122',
            longitude: '120.4412',
            order: true,
        },
        {
            name: '育仁醫院',
            city: '雲林縣',
            district: '西螺鎮',
            address: '雲林縣西螺鎮延平路162號',
            latitude: '23.80135',
            longitude: '120.4609',
            order: true,
        },
        {
            name: '大林慈濟醫院',
            city: '嘉義縣',
            district: '大林鎮',
            address: '嘉義縣大林鎮平林里民生路2號',
            latitude: '23.59631',
            longitude: '120.4575',
            order: true,
        },
        {
            name: '衛福部朴子醫院',
            city: '嘉義縣',
            district: '朴子市',
            address: '嘉義縣朴子市永和里5鄰應菜埔4250號',
            latitude: '23.464625',
            longitude: '120.2346',
            order: true,
        },
        {
            name: '嘉義長庚醫院',
            city: '嘉義縣',
            district: '朴子市',
            address: '嘉義縣朴子市仁和里嘉朴路西段6號',
            latitude: '23.46481',
            longitude: '120.284',
            order: true,
        },
        {
            name: '臺中榮民總醫院-灣橋分院',
            city: '嘉義縣',
            district: '竹崎鄉',
            address: '嘉義縣竹崎鄉灣橋村石麻園38號',
            latitude: '23.487889',
            longitude: '120.506537',
            order: true,
        },
        {
            name: '嘉義基督教醫院',
            city: '嘉義市',
            district: '東區',
            address: '嘉義市東區中庄里忠孝路539號',
            latitude: '23.4994',
            longitude: '120.4501',
            order: true,
        },
        {
            name: '聖馬爾定醫院-本院',
            city: '嘉義市',
            district: '東區',
            address: '嘉義市東區短竹里大雅路二段565號',
            latitude: '23.47685',
            longitude: '120.4663',
            order: true,
        },
        {
            name: '聖馬爾定醫院-民權院區',
            city: '嘉義市',
            district: '東區',
            address: '嘉義市東區民權路60號',
            latitude: '23.48418',
            longitude: '120.4615',
            order: true,
        },
        {
            name: '建興醫院',
            city: '嘉義市',
            district: '東區',
            address: '嘉義市東區內安里中山路148號',
            latitude: '23.48184',
            longitude: '120.4552',
            order: true,
        },
        {
            name: '陽明醫院',
            city: '嘉義市',
            district: '東區',
            address: '嘉義市東區吳鳳北路252號',
            latitude: '23.48057',
            longitude: '120.4532',
            order: true,
        },
        {
            name: '衛福部嘉義醫院',
            city: '嘉義市',
            district: '西區',
            address: '嘉義市西區北港路312號',
            latitude: '23.48117',
            longitude: '120.4291',
            order: true,
        },
        {
            name: '臺中榮民總醫院-嘉義分院',
            city: '嘉義市',
            district: '西區',
            address: '嘉義市西區劉厝里世賢路二段600號',
            latitude: '23.46755',
            longitude: '120.423',
            order: true,
        },
        {
            name: '陳仁德醫院',
            city: '嘉義市',
            district: '西區',
            address: '嘉義市西區林森西路285號',
            latitude: '23.48017',
            longitude: '120.4432',
            order: true,
        },
        {
            name: '慶昇醫院',
            city: '嘉義市',
            district: '西區',
            address: '嘉義市西區新榮路339-1號',
            latitude: '23.48003',
            longitude: '120.444',
            order: true,
        },
        {
            name: '盧亞人醫院',
            city: '嘉義市',
            district: '西區',
            address: '嘉義市西區民權路406號',
            latitude: '23.48209',
            longitude: '120.4476',
            order: true,
        },
        {
            name: '世華醫院',
            city: '嘉義市',
            district: '西區',
            address: '嘉義市西區仁愛路365號',
            latitude: '23.47569',
            longitude: '120.4421',
            order: true,
        },
        {
            name: '安心醫院',
            city: '嘉義市',
            district: '西區',
            address: '嘉義市西區新民路88號',
            latitude: '23.45332',
            longitude: '120.4334',
            order: true,
        },
        {
            name: '祥太醫院',
            city: '嘉義市',
            district: '西區',
            address: '嘉義市西區書院里延平街490號',
            latitude: '23.47598',
            longitude: '120.4405',
            order: true,
        },
        {
            name: '潮州安泰醫院',
            city: '屏東縣',
            district: '潮州鎮',
            address: '屏東縣潮州鎮三星里四維路162號',
            latitude: '22.55403',
            longitude: '120.547',
            order: true,
        },
        {
            name: '茂隆骨科醫院',
            city: '屏東縣',
            district: '潮州鎮',
            address: '屏東縣潮州鎮朝昇路322號',
            latitude: '22.55619',
            longitude: '120.5392',
            order: true,
        },
        {
            name: '安泰醫院',
            city: '屏東縣',
            district: '東港鎮',
            address: '屏東縣東港鎮中正路一段210號',
            latitude: '22.47433',
            longitude: '120.4591',
            order: true,
        },
        {
            name: '輔英科技大學附設醫院',
            city: '屏東縣',
            district: '東港鎮',
            address: '屏東縣東港鎮中山路５號',
            latitude: '22.4652',
            longitude: '120.4527',
            order: true,
        },
        {
            name: '枋寮醫院',
            city: '屏東縣',
            district: '枋寮鄉',
            address: '屏東縣枋寮鄉安樂村中山路139號',
            latitude: '22.36414',
            longitude: '120.5968',
            order: true,
        },
        {
            name: '聖恩內科醫院',
            city: '屏東縣',
            district: '高樹鄉',
            address: '屏東縣高樹鄉田子村勝利路132號',
            latitude: '22.805',
            longitude: '120.5789',
            order: true,
        },
        {
            name: '大新醫院',
            city: '屏東縣',
            district: '高樹鄉',
            address: '屏東縣高樹鄉長榮村興中路208號',
            latitude: '22.82379',
            longitude: '120.5996',
            order: true,
        },
        {
            name: '衛福部恆春旅遊醫院',
            city: '屏東縣',
            district: '恆春鎮',
            address: '屏東縣恆春鎮山腳里恆南路188號',
            latitude: '21.999421',
            longitude: '120.745178',
            order: true,
        },
        {
            name: '南門醫院',
            city: '屏東縣',
            district: '恆春鎮',
            address: '屏東縣恆春鎮南門路10號',
            latitude: '22.00086',
            longitude: '120.7454',
            order: true,
        },
        {
            name: '恆春基督教醫院',
            city: '屏東縣',
            district: '恆春鎮',
            address: '屏東縣恆春鎮山腳里恆西路21號',
            latitude: '22.002438',
            longitude: '120.741646',
            order: true,
        },
        {
            name: '屏安醫院-麟洛院區',
            city: '屏東縣',
            district: '麟洛鄉',
            address: '屏東縣麟洛鄉麟蹄村中山路160-1號',
            latitude: '22.65043',
            longitude: '120.5281',
            order: true,
        },
        {
            name: '高雄榮民總醫院-屏東分院',
            city: '屏東縣',
            district: '內埔鄉',
            address: '屏東縣內埔鄉龍潭村昭勝路安平1巷1號',
            latitude: '22.674758',
            longitude: '120.599266',
            order: true,
        },
        {
            name: '佑青醫院',
            city: '屏東縣',
            district: '內埔鄉',
            address: '屏東縣內埔鄉建興村建興路218巷19號',
            latitude: '22.66607',
            longitude: '120.5676',
            order: true,
        },
        {
            name: '衛福部屏東醫院',
            city: '屏東縣',
            district: '屏東市',
            address: '屏東縣屏東市自由路270號',
            latitude: '22.67326',
            longitude: '120.4955',
            order: true,
        },
        {
            name: '國軍高雄總醫院-屏東民眾診療服務處',
            city: '屏東縣',
            district: '屏東市',
            address: '屏東縣屏東市大湖路58巷22號',
            latitude: '22.6335',
            longitude: '120.4876',
            order: true,
        },
        {
            name: '寶建醫院-本院',
            city: '屏東縣',
            district: '屏東市',
            address: '屏東縣屏東市中山路123號',
            latitude: '22.6818',
            longitude: '120.4844',
            order: true,
        },
        {
            name: '寶建醫院-自由院區',
            city: '屏東縣',
            district: '屏東市',
            address: '屏東縣屏東市自由路650-1號',
            latitude: '22.68333',
            longitude: '120.4818',
            order: true,
        },
        {
            name: '安和醫院',
            city: '屏東縣',
            district: '屏東市',
            address: '屏東縣屏東市崇蘭里自由路598號',
            latitude: '22.68341',
            longitude: '120.4837',
            order: true,
        },
        {
            name: '優生醫院',
            city: '屏東縣',
            district: '屏東市',
            address: '屏東縣屏東市華山里瑞光路三段103號',
            latitude: '22.68611',
            longitude: '120.5039',
            order: true,
        },
        {
            name: '屏東基督教醫院-本院',
            city: '屏東縣',
            district: '屏東市',
            address: '屏東縣屏東市大連路60號',
            latitude: '22.68204',
            longitude: '120.5026',
            order: true,
        },
        {
            name: '屏東基督教醫院-瑞光院區',
            city: '屏東縣',
            district: '屏東市',
            address: '屏東縣屏東市建豐路2巷113號',
            latitude: '22.68091',
            longitude: '120.5052',
            order: true,
        },
        {
            name: '復興醫院',
            city: '屏東縣',
            district: '屏東市',
            address: '屏東縣屏東市民生路147-3號',
            latitude: '22.66854',
            longitude: '120.4957',
            order: true,
        },
        {
            name: '國仁醫院',
            city: '屏東縣',
            district: '屏東市',
            address: '屏東縣屏東市民生東路12-2號',
            latitude: '22.6583',
            longitude: '120.5146',
            order: true,
        },
        {
            name: '民眾醫院',
            city: '屏東縣',
            district: '屏東市',
            address: '屏東縣屏東市泰安里忠孝路120-1號',
            latitude: '22.67641',
            longitude: '120.4876',
            order: true,
        },
        {
            name: '迦樂醫院',
            city: '屏東縣',
            district: '新埤鄉',
            address: '屏東縣新埤鄉箕湖村進化路12-200號',
            latitude: '22.46334',
            longitude: '120.6155',
            order: true,
        },
        {
            name: '屏安醫院-本院',
            city: '屏東縣',
            district: '長治鄉',
            address: '屏東縣長治鄉榮華村信義路129號',
            latitude: '22.66986',
            longitude: '120.568',
            order: true,
        },
        {
            name: '杏和醫院',
            city: '宜蘭縣',
            district: '礁溪鄉',
            address: '宜蘭縣礁溪鄉礁溪路4段129號',
            latitude: '24.82058',
            longitude: '121.7691',
            order: true,
        },
        {
            name: '羅東博愛醫院',
            city: '宜蘭縣',
            district: '羅東鎮',
            address: '宜蘭縣羅東鎮南昌街81號',
            latitude: '24.67168',
            longitude: '121.7731',
            order: true,
        },
        {
            name: '羅東聖母醫院',
            city: '宜蘭縣',
            district: '羅東鎮',
            address: '宜蘭縣羅東鎮中正南路160號',
            latitude: '24.67143',
            longitude: '121.7707',
            order: true,
        },
        {
            name: '臺北榮民總醫院-蘇澳分院(本院)',
            city: '宜蘭縣',
            district: '蘇澳鎮',
            address: '宜蘭縣蘇澳鎮蘇濱路一段301號',
            latitude: '24.6141',
            longitude: '121.8486',
            order: true,
        },
        {
            name: '臺北榮民總醫院-蘇澳分院(門診中心)',
            city: '宜蘭縣',
            district: '蘇澳鎮',
            address: '宜蘭縣蘇澳鎮中山路一段439號',
            latitude: '24.59622',
            longitude: '121.8396',
            order: true,
        },
        {
            name: '國立陽明大學附設醫院-宜蘭院區',
            city: '宜蘭縣',
            district: '宜蘭市',
            address: '宜蘭縣宜蘭市校舍路169號',
            latitude: '24.75005',
            longitude: '121.758',
            order: true,
        },
        {
            name: '國立陽明大學附設醫院-新民院區',
            city: '宜蘭縣',
            district: '宜蘭市',
            address: '宜蘭縣宜蘭市新民路152號',
            latitude: '24.75785',
            longitude: '121.754',
            order: true,
        },
        {
            name: '臺北榮民總醫院-員山分院(門診部)',
            city: '宜蘭縣',
            district: '宜蘭市',
            address: '宜蘭縣宜蘭市林森路1號',
            latitude: '24.75037',
            longitude: '121.7577',
            order: true,
        },
        {
            name: '蘭陽仁愛醫院',
            city: '宜蘭縣',
            district: '宜蘭市',
            address: '宜蘭縣宜蘭市中山路二段260號',
            latitude: '24.74874',
            longitude: '121.7544',
            order: true,
        },
        {
            name: '臺北榮民總醫院-員山分院(本院)',
            city: '宜蘭縣',
            district: '員山鄉',
            address: '宜蘭縣員山鄉榮光路386號',
            latitude: '24.72192',
            longitude: '121.6878',
            order: true,
        },
        {
            name: '臺北榮民總醫院-員山鄉(門診部)',
            city: '宜蘭縣',
            district: '員山鄉',
            address: '宜蘭縣宜蘭縣員山鄉員山路一段325號',
            latitude: '24.745482',
            longitude: '121.723656',
            order: true,
        },
        {
            name: '員山馬偕醫院',
            city: '宜蘭縣',
            district: '員山鄉',
            address: '宜蘭縣員山鄉深溝村尚深路91號',
            latitude: '24.72146',
            longitude: '121.7216',
            order: true,
        },
        {
            name: '海天醫院',
            city: '宜蘭縣',
            district: '壯圍鄉',
            address: '宜蘭縣壯圍鄉古亭路23-9號',
            latitude: '24.77916',
            longitude: '121.8105',
            order: true,
        },
        {
            name: '臺中榮民總醫院-埔里分院',
            city: '南投縣',
            district: '埔里鎮',
            address: '南投縣埔里鎮蜈蚣里榮光路1號',
            latitude: '23.9758',
            longitude: '120.9968',
            order: true,
        },
        {
            name: '埔里基督教醫院',
            city: '南投縣',
            district: '埔里鎮',
            address: '南投縣埔里鎮鐵山路1號',
            latitude: '23.97093',
            longitude: '120.9468',
            order: true,
        },
        {
            name: '衛福部草屯療養院',
            city: '南投縣',
            district: '草屯鎮',
            address: '南投縣草屯鎮玉屏路161號',
            latitude: '23.9904',
            longitude: '120.7045',
            order: true,
        },
        {
            name: '佑民醫院',
            city: '南投縣',
            district: '草屯鎮',
            address: '南投縣草屯鎮太平路一段200號',
            latitude: '23.96054',
            longitude: '120.6819',
            order: true,
        },
        {
            name: '中國醫藥大學附設醫院-草屯分院',
            city: '南投縣',
            district: '草屯鎮',
            address: '南投縣草屯鎮平等街140號',
            latitude: '23.98474',
            longitude: '120.6859',
            order: true,
        },
        {
            name: '曾漢棋綜合醫院',
            city: '南投縣',
            district: '草屯鎮',
            address: '南投縣草屯鎮虎山路915號',
            latitude: '23.97856',
            longitude: '120.6857',
            order: true,
        },
        {
            name: '新泰宜婦幼醫院',
            city: '南投縣',
            district: '名間鄉',
            address: '南投縣名間鄉新街村彰南路571-1號',
            latitude: '23.88202',
            longitude: '120.691',
            order: true,
        },
        {
            name: '衛生福利部南投醫院-本院',
            city: '南投縣',
            district: '南投市',
            address: '南投縣南投市復興路478號',
            latitude: '23.91409',
            longitude: '120.6853',
            order: true,
        },
        {
            name: '衛生福利部南投醫院-中興院區',
            city: '南投縣',
            district: '南投市',
            address: '南投縣南投市中興新村環山路57號',
            latitude: '23.95239',
            longitude: '120.6948',
            order: true,
        },
        {
            name: '南基醫院',
            city: '南投縣',
            district: '南投市',
            address: '南投縣南投市中興路870號',
            latitude: '23.89883',
            longitude: '120.6839',
            order: true,
        },
        {
            name: '竹山秀傳醫院',
            city: '南投縣',
            district: '竹山鎮',
            address: '南投縣竹山鎮集山路二段75號',
            latitude: '23.80015',
            longitude: '120.7141',
            order: true,
        },
        {
            name: '東華醫院',
            city: '南投縣',
            district: '竹山鎮',
            address: '南投縣竹山鎮集山路三段272巷16號',
            latitude: '23.76438',
            longitude: '120.7003',
            order: true,
        },
        {
            name: '衛福部花蓮醫院-豐濱原住民分院',
            city: '花蓮縣',
            district: '豐濱鄉',
            address: '花蓮縣豐濱鄉光豐路41號',
            latitude: '23.60198',
            longitude: '121.5213',
            order: true,
        },
        {
            name: '臺北榮民總醫院-鳳林分院',
            city: '花蓮縣',
            district: '鳳林鎮',
            address: '花蓮縣鳳林鎮中正路一段2號',
            latitude: '23.72743',
            longitude: '121.4392',
            order: true,
        },
        {
            name: '衛福部花蓮醫院',
            city: '花蓮縣',
            district: '花蓮市',
            address: '花蓮縣花蓮市中正路600號',
            latitude: '23.97948',
            longitude: '121.6112',
            order: true,
        },
        {
            name: '花蓮慈濟醫院',
            city: '花蓮縣',
            district: '花蓮市',
            address: '花蓮縣花蓮市中央路三段707號',
            latitude: '23.99573',
            longitude: '121.5923',
            order: true,
        },
        {
            name: '門諾醫院',
            city: '花蓮縣',
            district: '花蓮市',
            address: '花蓮縣花蓮市民權路44號',
            latitude: '23.98826',
            longitude: '121.6266',
            order: true,
        },
        {
            name: '門諾醫院-壽豐分院',
            city: '花蓮縣',
            district: '壽豐鄉',
            address: '花蓮縣壽豐鄉共和村魚池52號',
            latitude: '23.869546',
            longitude: '121.526684',
            order: true,
        },
        {
            name: '國軍花蓮總醫院-民眾診療服務處',
            city: '花蓮縣',
            district: '新城鄉',
            address: '花蓮縣新城鄉嘉里路163號',
            latitude: '24.02443',
            longitude: '121.6074',
            order: true,
        },
        {
            name: '衛福部玉里醫院',
            city: '花蓮縣',
            district: '玉里鎮',
            address: '花蓮縣玉里鎮中華路448號',
            latitude: '23.34749',
            longitude: '121.3208',
            order: true,
        },
        {
            name: '臺北榮民總醫院-玉里分院',
            city: '花蓮縣',
            district: '玉里鎮',
            address: '花蓮縣玉里鎮新興街91號',
            latitude: '23.33921',
            longitude: '121.312',
            order: true,
        },
        {
            name: '玉里慈濟醫院',
            city: '花蓮縣',
            district: '玉里鎮',
            address: '花蓮縣玉里鎮民權街1-1號',
            latitude: '23.33466',
            longitude: '121.3185',
            order: true,
        },
        {
            name: '衛福部臺東醫院-成功分院',
            city: '臺東縣',
            district: '成功鎮',
            address: '臺東縣成功鎮中山東路32號',
            latitude: '23.0993',
            longitude: '121.3778',
            order: true,
        },
        {
            name: '關山慈濟醫院',
            city: '臺東縣',
            district: '關山鎮',
            address: '臺東縣關山鎮和平路125-5號',
            latitude: '23.05722',
            longitude: '121.1667',
            order: true,
        },
        {
            name: '衛福部臺東醫院',
            city: '臺東縣',
            district: '臺東市',
            address: '臺東縣臺東市五權街1號',
            latitude: '22.75781',
            longitude: '121.1499',
            order: true,
        },
        {
            name: '臺北榮民總醫院-臺東分院(本院)',
            city: '臺東縣',
            district: '臺東市',
            address: '臺東縣臺東市更生路1000號',
            latitude: '22.77235',
            longitude: '121.1324',
            order: true,
        },
        {
            name: '臺北榮民總醫院-臺東分院(勝利院區)',
            city: '臺東縣',
            district: '臺東市',
            address: '臺東縣臺東市勝利街2號',
            latitude: '22.76059',
            longitude: '121.1585',
            order: true,
        },
        {
            name: '臺東馬偕醫院',
            city: '臺東縣',
            district: '臺東市',
            address: '臺東縣臺東市長沙街303巷1號',
            latitude: '22.751253',
            longitude: '121.141231',
            order: true,
        },
        {
            name: '臺東基督教醫院',
            city: '臺東縣',
            district: '臺東市',
            address: '臺東縣臺東市開封街350號',
            latitude: '22.76382',
            longitude: '121.146',
            order: true,
        },
        {
            name: '天主教臺東聖母醫院',
            city: '臺東縣',
            district: '臺東市',
            address: '臺東縣臺東市民族里21鄰杭州街2號',
            latitude: '22.75763',
            longitude: '121.1464',
            order: true,
        },
    ],
    careOrderTimeSelection: {
        ESTBufferHours: 1,
        ESTFurthestDays: 10,
        maxServiceDays: 7,
    },
    careOrderPlan: {
        partTime: [8, 10, 12],
    },
    fee: {
        partTimeCareOrder: {
            basicHourlyServiceFee: 176,
            basicHourlyFee: 203,
            platformFeePercentage: 0.15,
        },
        allDayCareOrder: {
            basicDailyServiceFee: 2700,
            basicDailyFee: 3105,
            platformFeePercentage: 0.15,
        },
        cancellation: {
            cancellationFee: 200,
        },
    },
};
